<template lang="pug">
#send-document-edit(v-cloak)
  .box
    .box-header.register-header
      .title
        span 文書送付の修正
      .register-row(v-show="errorMessage")
        .register-group
          .register-value
            .error-message {{ errorMessage }}
    //- nonsended document
    .box-body.register-body(v-if="beforeSendDocument != null && beforeSendDocument.isSended == false")
      //- send type
      FormInputRadio(
        v-model="type"
        key-name="宛先種別" name="type" :options="_typeOptions"
        @change="changeType"
        :validation-rules="{ required: true }" required)
      //- select targets
      FormSendTarget(
        v-if="type != null && type != 'allFamilies'"
        v-model="targets" :isBusy="isSendTargetBusy"
        key-name="宛先" name="targets" required
        @change="changeUnit()" @onTargetSelect="onTargetSelect(type)" @onDeleteMember="onDeleteTarget")
      //- select unit
      FormInputRadio(
        v-if="type != null"
        v-model="unit"
        key-name="文書の配信単位" name="unit" :options="unitOptions"
        :validation-rules="{ required: true }" required)
        template(v-slot:question)
          HelpIcon(popoverId="unit-help-text" title="利用者ごとに異なる文書について")
            template(v-slot:text)
              div ご利用者ごとに異なる文書（計画書等）を登録して送信すると、そのご家族のみが文書を見ることが出来ます。
              div メッセージと同意取得は一斉配信できますので、送付後の同意確認結果は一覧で確認できます。
      //- same file selecter
      .register-row(v-if="unit == 0")
        .register-group
          .register-key
            .left-side.d-flex
              span.key-name 添付文書
              span.validation-label 必須
              HelpIcon(popoverId="attached-files-help-text" title="添付文書のファイルについて")
                template(#text)
                  div PDFファイルを最大9ファイルまで添付することが出来ます。
                  div PDFファイルは変換せずにそのまま送付いたします。
          .register-value
            MultiFileSelecter(name="same-files" :mimetypes="[ 'application/pdf' ]" :limit="_sameFilesLimit"
              :showPreview="true" :enablePreviewStatus="_enableSameFilesPreview" @input="inputSameFiles" @preview="onSameFilePreview")
          .error-messages.text-break(v-for="error in errors.collect('same-files')")
            label.error-message {{ error }}
            br
      div(style="margin: 0 20px 0 20px;")
        DraggableFiles(v-if="unit == 0" v-model="sameFiles" @delete="onSameFileDelete" :item-width="'468px'")
      //- separate file selecter
      .register-row(v-if="unit == 1")
        .register-group
          .register-key
            span.key-name 添付文書
            span.validation-label 必須
            HelpIcon(popoverId="attached-files-help-text" title="添付文書のファイルについて")
              template(#text)
                div PDFファイルを最大9ファイルまで添付することが出来ます。
                div PDFファイルは変換せずにそのまま送付いたします。
          .register-value
            button.btn.separate-file-select-btn.mr-2(@click="onSelectSeparateFile") ファイルを選択
          .register-value.mt-2(v-if="0 < separateFiles.length")
            .d-flex.flex-row.align-items-center
              span ファイル選択済み
              button.btn.preview-btn(@click="onSelectSeparateFile") プレビュー
          .error-messages.text-break(v-for="error in errors.collect('separate-files')")
            label.error-message {{ error }}
            br
      //- select template
      FormInputSelect(v-if="1 <= planType" v-model="templateId" key-name="テンプレート" name="template-id" :options="templateOptions" :styles="{ 'width': '600px' }")
      .register-row(v-show="planType < 1")
        .register-group
          .register-key
            span.key-name テンプレート
          #disable-template.register-value
            select.register-form.input-select.disable(disabled style="width: 600px;")
              option ※ ライトプラン以上で使用可能
          b-popover(target="disable-template" triggers="hover" placement="top")
            template(v-slot:title) テンプレート
            span タイトル、本文、見ましたボタン、既読確認メッセージ、返信ボタンをテンプレートとして保存し、メッセージ作成時に使用することができます。
            br
            span ※ ライトプラン以上で使用可能
      //- category
      FormInputSelect(v-model="categoryId" :options="categoryOptions"
        key-name="文書種類" name="category" :validation-rules="{ required: true }" required)
      //- title and text
      FormInput(
        v-model="title"
        key-name="タイトル" name="title" type="text" placeholder="タイトル"
        :validation-rules="{ required: true, max: 100 }" :maxlength="100"
        :styles="{ maxWidth: '720px', width: '720px' }" required)
      FormTextarea(
        v-model="text"
        key-name="本文" name="text" placeholder="本文"
        :validation-rules="{ required: true, max: 1000 }" :maxlength="1000"
        :styles="{ maxWidth: '720px', width: '720px', minHeight: '160px' }" required)
      //- option check boxs
      .checkboxs.d-flex.flex-row.flex-wrap
        FormCheck(
          v-model="needAgreement"
          key-name="オプション" name="need-agreement" label="同意取得（同意返信）を付ける"
          :active="needConfirm == false" :disabled="needConfirm == true")
          template(v-slot:question)
            HelpIcon(popoverId="option-help-text" title="同意取得と確認取得のオプション")
              template(v-slot:text)
                div 同意取得もしくは確認取得のどちらかをオプション設定して送付、もしくはオプションを付けずに送付することが出来ます。
                div 受信者はLINEアプリから、同意／確認の登録が出来ます。同意／確認の登録時に、希望者は連絡事項も付与することが出来ます。
                div 同意もしくは確認の取得状況・返信内容は、管理システムの確認画面で確認できます。また同意者一覧もしくは確認者一覧をPDFファイルでダウンロードすることも出来ます。
        FormCheck.second-option(
          v-model="needConfirm"
          key-name="" name="need-confirm" label="確認取得（確認返信）を付ける"
          :active="needAgreement == false" :disabled="needAgreement == true")

    //- sended document
    .box-body.register-body(v-if="beforeSendDocument != null && beforeSendDocument.isSended == true")
      //- send datetime
      FormLabel(key-name="送付日時" :value="_sendDatetime")
      //- send type
      FormLabel(key-name="宛先種別" :value="_typeLabel")
      //- select targets
      FormLabel(key-name="宛先" :value="_sendTargetLabel")
      //- select unit
      FormLabel(key-name="文書の配信単位" :value="_unitLabel")
      //- same file selecter
      .register-row(v-if="_unit == 0")
        .register-group
          .register-key
            span.key-name 添付文書
          .register-value
            .d-flex.flex-column
              ul.list-group.mb-2(v-for="fileName in _fileNames")
                li.list-group-item.file-name {{ fileName }}
              button.btn.preview-btn(@click="onSameFilePreview") プレビュー
      //- separate file selecter
      .register-row(v-if="_unit == 1")
        .register-group
          .register-key
            span.key-name 添付文書
          .register-value
            button.btn.separate-file-select-btn(@click="onSeparateFileList") ファイル一覧
      //- category
      FormInputSelect(v-model="categoryId" :options="categoryOptions"
        key-name="文書種類" name="category" :validation-rules="{ required: true }" required)
      //- title and text
      FormLabel(key-name="タイトル" :value="_title")
      FormLabel(key-name="本文" :value="_text")
      //- option
      FormLabel(key-name="オプション" :value="_option")

    .box-footer.with-border.register-footer
      ValidationAlert(v-model="showValidationAlert")
      //- nonsended document
      .buttons(v-if="beforeSendDocument != null && beforeSendDocument.isSended == false")
        button.btn.register-btn(v-if="_showDraft" @click="showSaveDraftModal" type="button") 一時保存
        button.btn.register-btn(v-if="_permissions.useControl" @click="showSendConfirmModal" type="button") 送信・公開
        button.btn.cancel-btn(@click="gotoSendDocumentList" type="button") キャンセル
      //- sended document
      .buttons(v-if="beforeSendDocument != null && beforeSendDocument.isSended == true")
        button.btn.register-btn(@click="showSaveDraftModal" type="button") 更新
        button.btn.cancel-btn(@click="gotoSendDocumentList" type="button") キャンセル

  SendMessageSelectModal(ref="sendMessageSelectModal" @add="selectSendTargetFamilies")
  SendMessageOtherUserGroupSelectModal(ref="otherUserGroupSelectModal" @add="selectSendTargetOtherUserGroups")
  SendMessageGroupSelectModal(ref="sendMessageGroupSelectModal" :planType="planType" :groupType.sync="groupType" @add="selectSendTargetSendMessageGroups")
  
  SendMessageFilePreviewModal(ref="previewModal")
  SeparateFileSelectModal(v-model="showSeparateFileSelectModal"
    :items="separateFileTargetsItems" :rows.sync="separateFileTargetsRows" :isLoading="separateFileTargetsIsLoading"
    @ok="selectedSeparateFiles" @onCooperationSystemSelect="onCooperationSystemSelect")
  CooperationSystemSelectModal(v-model="showCooperationSystemSelectModal" @okByGoodTree="downloadGoodTreeFiles" @okByIMedic="downloadIMedicFiles" @okByToukei="downloadToukeiFiles")

  OkCancelModal(v-model="showUpdateModal" :title="updateModalMessage" @ok="updateSendDocument")
  OkModal(v-model="showUpdateSuccessModal" :title="updateSuccessModalMessage" @ok="gotoSendDocumentList")

  CheckInputOkCancelModal(v-model="showNotTempFileResidentsModal" :title="showNotTempFileResidentsModalTitle"
    :message="showNotTempFileResidentsModalMessage" :listItems="notTempFileResidentNames" @ok="sendDocument")
  CheckOkCancelModal(v-model="showSendModal" title="文書送付情報を送信・公開しますか？" 
    :showCheckbox.sync="showCheckbox" :checked.sync="checked" @ok="sendDocument")
  OkModal(v-model="showSendSuccessModal" title="送信を受け付けました" @ok="gotoSendDocumentList")
  
  SeparateFileListModal(v-model="showSeparateFileListModal"
    :items="separateFileTargetsItems" :rows.sync="separateFileTargetsRows" :isLoading="separateFileTargetsIsLoading")

  //- file upload error modal
  FileUploadErrorModal(v-model="showUploadErrorModal")

  PageLoading(:isBusy="isBusy" :message="loadingMessage")
  ProgressLoading(v-model="currentUploadCount" :max="uploadCount" :isBusy="progressLoading" :message="progressMessage")
</template>

<script lang="ts">
import { Component, Inject, Watch, Vue } from "vue-property-decorator";
import { userStore, screenInputTemporaryStore } from "@/store/store";

import CustomValidate from "@/commons/utils/CustomValidate";
import { PcUrl } from "@/commons/constants/PcUrl";
import Setting from "../../../../public/setting.json";
import SystemError from "@/commons/models/SystemError";

import SendDocumentsService, {
  FileUrl,
  Type,
  Unit,
  SendDocumentGetModel,
  SendDocumentFile,
  SendDocumentPatchModel,
  SendDocumentSendPostModel,
  SendMessageGroupInfo,
  SendDocumentFamilyReceiver,
  SendDocumentOtherUserReceiver,
  ResidentGroupInfo,
  GroupOtherUserGroupInfo
} from "@/commons/services/SendDocuments";
import FamiliesService, { FamilyGetModel } from "@/commons/services/Families";
import ResidentGroupsService, { ResidentGroupsGetModel } from "@/commons/services/ResidentGroups";
import OtherUserGroupsService from "@/commons/services/OtherUserGroups";
import OtherUserGroupMembersService from "@/commons/services/OtherUserGroupMembers";
import OtherUserGroup, { SenderType } from "@/commons/models/OtherUserGroup";
import OtherUserGroupTypeMembersService, { OtherUserGroupTypeGroup, OtherUserGroupTypeMember } from "@/commons/services/OtherUserGroupTypeMembers";
import OtherUserGroupTypesService from "@/commons/services/OtherUserGroupTypes";
import OtherUserGroupTypeModel from "@/commons/models/OtherUserGroupType";
import SendMessageGroupsService, { GroupType, SendMessageGroupsGetModel } from "@/commons/services/SendMessageGroups";
import SendMessageGroupMembersService, {
  SendMessageGroupMembersFamilyGetModel,
  SendMessageGroupMembersOtherUserGroupMemberGetModel
} from "@/commons/services/SendMessageGroupMembers";
import { PlanType } from "@/commons/services/Plans";
import S3LocationsService from "@/commons/services/S3Locations";
import S3UploadsService from "@/commons/services/S3Uploads";
import { S3MultiLocation, S3UploadFileInfo, S3UploadResponse, S3UploadResponseFile, S3UploadSendDocument, S3UploadType } from "@/commons/models/S3MultiLocation";
import S3UrlService from "@/commons/services/S3Url";
import ResidentsService, { ResidentGetModel, ResidentStatus } from "@/commons/services/Residents";
import SendDocumentCategoriesService, { SendDocumentCategoryGetModel } from "@/commons/services/SendDocumentCategories";
import GoodTreeFilesService, { GoodTreeFile } from "@/commons/services/GoodTreeFiles";
import IMedicFilesService, { IMedicFile } from "@/commons/services/IMedicFiles";
import ToukeiFilesService, { ToukeiFile } from "@/commons/services/ToukeiFiles";
import SendDocumentTemplatesService, { SendDocumentTemplatesGetModel, TemplateType } from "@/commons/services/SendDocumentTemplates";

import OkCancelModal from "@/pc/basics/OkCancelModal.vue";
import OkModal from "@/pc/basics/OkModal.vue";
import HelpIcon from "@/pc/basics/HelpIcon.vue";
import PageLoading from "@/pc/basics/PageLoading.vue";
import ValidationAlert from "@/pc/basics/ValidationAlertByValidator.vue";
import ProgressLoading from "@/pc/basics/ProgressLoading.vue";
import FormInputRadio from "@/pc/components/forms/FormInputRadio.vue";
import FormInputSelect from "@/pc/components/forms/FormInputSelect.vue";
import FormInput from "@/pc/components/forms/FormInput.vue";
import FormTextarea from "@/pc/components/forms/FormTextarea.vue";
import FormCheck from "@/pc/components/forms/FormCheck.vue";
import FormSendTarget, { SendTarget } from "@/pc/components/forms/FormSendTarget.vue";
import FormLabel from "@/pc/components/forms/FormLabel.vue";
import MultiFileSelecter from "@/pc/basics/MultiFileSelecter.vue";
import DraggableFiles from "@/pc/components/DraggableFiles.vue";
import { GroupModel, OtherUserGroupTargetModel, ResidentGroupTargetModel, SendMessageGroupTargetModel } from "@/pc/containers/sendMessages/SendMessageForm.vue";
import { SendMessageTargetGroup } from "@/commons/models/SendMessageTarget";

import FileUploadErrorModal from "@/pc/basics/FileUploadErrorModal.vue";
import SendMessageSelectModal from "@/pc/components/modals/SendMessageSelectModal.vue";
import SendMessageOtherUserGroupSelectModal from "@/pc/components/modals/SendMessageOtherUserGroupSelectModal.vue";
import SendMessageGroupSelectModal from "@/pc/components/modals/SendMessageGroupSelectModal.vue";
import SendMessageFilePreviewModal from "@/pc/components/modals/SendMessageFilePreviewModal.vue";
import SeparateFileSelectModal, { SendTargetExtFiles } from "@/pc/containers/sendDocuments/SeparateFileSelectModal.vue";
import SeparateFileListModal from "@/pc/containers/sendDocuments/SeparateFileListModal.vue";
import CooperationSystemSelectModal from "@/pc/containers/sendDocuments/CooperationSystemSelectModal.vue";
import { SeparateFileSelectTableItem } from "@/pc/containers/sendDocuments/SeparateFileSelectTable.vue";
import { SeparateFileTableItem } from "@/pc/containers/sendDocuments/SeparateFileTable.vue";
import CheckInputOkCancelModal from "@/pc/containers/sendDocuments/CheckInputOkCancelModal.vue";
import CheckOkCancelModal from "@/pc/containers/sendDocuments/CheckOkCancelModal.vue";
import { SendDocumentsFunction } from "@/commons/services/Authorization";

/**
 * ### 文書送付登録画面コンポーネント
 */
@Component({
  components: {
    FileUploadErrorModal,
    OkCancelModal,
    CheckOkCancelModal,
    OkModal,
    HelpIcon,
    PageLoading,
    ProgressLoading,
    ValidationAlert,
    FormInputRadio,
    FormInputSelect,
    FormInput,
    FormTextarea,
    FormCheck,
    FormSendTarget,
    FormLabel,
    MultiFileSelecter,
    DraggableFiles,
    SendMessageSelectModal,
    SendMessageOtherUserGroupSelectModal,
    SendMessageGroupSelectModal,
    SendMessageFilePreviewModal,
    SeparateFileSelectModal,
    SeparateFileListModal,
    CooperationSystemSelectModal,
    CheckInputOkCancelModal
  },
  $_veeValidate: { validator: "new" }
})
export default class SendDocumentEdit extends Vue {
  /** 文書送付サービス */
  @Inject("SendDocumentsService") sendDocumentsService!: SendDocumentsService;
  /** 家族サービス */
  @Inject("FamiliesService") familiesService!: FamiliesService;
  /** 利用者グループサービス */
  @Inject("ResidentGroupsService") residentGroupsService!: ResidentGroupsService;
  /** 施設関係者グループサービス */
  @Inject("OtherUserGroupsService") otherUserGroupsService!: OtherUserGroupsService;
  /** 施設関係者グループメンバー取得サービス */
  @Inject("OtherUserGroupMembersService") otherUserGroupMembersService!: OtherUserGroupMembersService;
  /** 施設関係者グループ種類にひもづくメンバー取得サービス */
  @Inject("OtherUserGroupTypeMembersService") otherUserGroupTypeMembersService!: OtherUserGroupTypeMembersService;
  /** 施設関係者グループ種類サービス */
  @Inject("OtherUserGroupTypesService") otherUserGroupTypesService!: OtherUserGroupTypesService;
  /** 宛先グループサービス */
  @Inject("SendMessageGroupsService") sendMessageGroupsService!: SendMessageGroupsService;
  /** 宛先グループメンバーサービス */
  @Inject("SendMessageGroupMembersService") sendMessageGroupMembersService!: SendMessageGroupMembersService;
  /** S3格納先URLサービス */
  @Inject("S3LocationsService") s3LocationsService!: S3LocationsService;
  /** S3ファイルアップロードサービス */
  @Inject("S3UploadsService") s3UploadsService!: S3UploadsService;
  /** S3Urlサービス */
  @Inject("S3UrlService") s3UrlService!: S3UrlService;
  /** 利用者サービス */
  @Inject("ResidentsService") residentsService!: ResidentsService;
  /** 文書送付カテゴリーサービス */
  @Inject("SendDocumentCategoriesService") categoriesService!: SendDocumentCategoriesService;
  /** グッドツリー連携ファイルサービス */
  @Inject("GoodTreeFilesService") goodTreeFilesService!: GoodTreeFilesService;
  /** iMedic連携ファイルサービス */
  @Inject("IMedicFilesService") iMedicFilesService!: IMedicFilesService;
  /** 福祉見聞録（東経システム）連携ファイルサービス */
  @Inject("ToukeiFilesService") toukeiFilesService!: ToukeiFilesService;
  /** 文書送付テンプレートサービス */
  @Inject("SendDocumentTemplatesService") sendDocumentTemplatesService!: SendDocumentTemplatesService;

  /** ページ全体ローディング表示可否 */
  isBusy: boolean = false;
  /** ローディングメッセージ */
  loadingMessage: string = "";
  /** 宛先候補ローディング表示可否 */
  isSendTargetBusy: boolean = false;
  /** プラン種別 */
  planType: PlanType = PlanType.UNKNOWN;

  /** ID */
  mainId: number | null = null;
  /** 編集前文書送付 */
  beforeSendDocument: SendDocumentGetModel | null = null;
  /** 利用者ごとの異なる文書のファイルリストモーダル表示可否 */
  showSeparateFileListModal: boolean = false;

  /** 公開状態 */
  isPublic: boolean = false;
  /** 宛先種別 */
  type: SendMessageTarget | null = null;
  /** 宛先グループの種別（宛先グループや利用者グループなど） */
  groupType: GroupType = GroupType.UNKNOWN;
  /** 宛先種別選択肢 */
  typeOptions: Array<{ value: number | string; label: string }> = [
    { value: Type.ALL_FAMILY, label: "家族全員" },
    { value: Type.SELECTED_FAMILY, label: "家族個別" },
    { value: Type.SELECTED_OTHER_USER, label: "施設関係者個別" },
    { value: Type.SEND_MESSAGE_GROUP, label: "宛先グループ" }
  ];
  /** 宛先選択結果 */
  targets: Array<SendTarget> = [];
  /** 宛先候補(家族全体) */
  targetAllFamilies: Array<FamilyGetModel> | null = null;
  /** 宛先候補(家族個別) */
  targetFamilies: Array<SendTargetResidentGroup> | null = null;
  /** 宛先候補(施設関係者個別) */
  targetOtherUsers: Array<OtherUserGroupTypeGroup> | null = null;
  /** 宛先候補(宛先グループ) */
  targetGroups: GroupModel | null = null;
  /** 利用者グループMap(key:利用者グループID value:利用者グループ) */
  residentGroupMap: Map<number, ResidentGroupsGetModel> = new Map<number, ResidentGroupsGetModel>();
  /** 施設関係者種類Map(key:施設関係者種類ID value:施設関係者種類名) */
  otherUserGroupTypesMap: Map<number, string> = new Map<number, string>();
  /** 施設にひもづく施設関係者メンバー */
  otherUserGroupMembersInFacility: Array<OtherUserGroup> = [];

  /** 利用者MAP(key：利用者ID) */
  residentMapById: Map<number, ResidentGetModel> = new Map<number, ResidentGetModel>();

  /** 文書単位 */
  unit: Unit | null = null;
  /** 文書の配信単位選択肢 */
  unitOptions: Array<{ value: number | string; label: string }> = [];

  /** 既存ファイルURL */
  fileUrls: Array<FileUrl> = [];
  /** 宛先全員同じ文章のファイル */
  sameFiles: Array<File> = [];
  /** 利用者ごとの異なる文書のファイル選択モーダル表示可否 */
  showSeparateFileSelectModal: boolean = false;
  /** 利用者ごとの異なる文書の宛先対象 */
  separateFileTargets: Array<SendTargetExtFiles> = [];
  /** 利用者ごとの異なる文書のファイル選択モーダルの宛先対象 */
  separateFileTargetsItems: Array<SeparateFileSelectTableItem> = [];
  /** 利用者ごとの異なる文書の宛先行数 */
  separateFileTargetsRows: number = 0;
  /** 利用者ごとの異なる文書の宛先ローディング */
  separateFileTargetsIsLoading: boolean = false;
  /** 利用者ごとの異なる文書の選択ファイル */
  separateFiles: Array<ResidentSeparateFiles> = [];

  /** 連携ファイル選択モーダル表示可否 */
  showCooperationSystemSelectModal: boolean = false;

  /** 使用するメッセージ送信テンプレート */
  templateId: number = 0;
  /** メッセージ送信テンプレート選択肢 */
  templateOptions: Array<{ value: number; label: string }> = [];
  /** メッセージ送信テンプレートMAP */
  templateIdMap: Map<number, SendDocumentTemplatesGetModel> = new Map();

  /** カテゴリ */
  categoryId: number | null = null;
  /** カテゴリ選択肢 */
  categoryOptions: Array<{ value: number | string; label: string }> = [];
  /** 文書送付カテゴリMAP(key:id, value:name) */
  categoryMap: Map<number, string> = new Map<number, string>();
  /** カテゴリ情報、テンプレート選択時に使用する */
  categories: Array<SendDocumentCategoryGetModel> = [];
  /** タイトル */
  title: string | null = null;
  /** 本文 */
  text: string | null = null;
  /** 確認しましたボタンを付与するか */
  needConfirm: boolean = false;
  /** 同意しましたボタンを付与するか */
  needAgreement: boolean = false;
  /** 更新日時 */
  updated: number | null = null;

  /** 一時保存/更新確認モーダルの表示可否 */
  showUpdateModal: boolean = false;
  /** 一時保存/更新モーダルメッセージ */
  updateModalMessage: string = "";
  /** 一時保存/更新完了モーダルの表示可否 */
  showUpdateSuccessModal: boolean = false;
  /** 一時保存/更新完了モーダルメッセージ */
  updateSuccessModalMessage: string = "";

  /** 利用者にファイルが添付されていない注意喚起モーダル */
  showNotTempFileResidentsModal: boolean = false;
  /** 利用者にファイルが添付されていない注意喚起モーダルタイトル */
  showNotTempFileResidentsModalTitle: string = "";
  /** 利用者にファイルが添付されていない注意喚起モーダルメッセージ */
  showNotTempFileResidentsModalMessage: string = "";
  /** 利用者にファイルが添付されていない注意喚起モーダルの対象利用者名 */
  notTempFileResidentNames: string[] = [];
  /** 送信・公開確認モーダルの表示可否 */
  showSendModal: boolean = false;
  /** 家族全員へのメッセージで良いでしょうか？のチェックボックスを表示するか否か */
  showCheckbox: boolean = false;
  /** 家族全員へのメッセージで良いでしょうか？のチェックボックスのチェック */
  checked: boolean = false;
  /** 送信・公開受付完了モーダルの表示可否 */
  showSendSuccessModal: boolean = false;
  /** 宛先種別が宛先グループの場合の種別 */
  sendMessageGroupType: GroupType = GroupType.UNKNOWN;

  /** 現在のアップロード数 */
  currentUploadCount: number = 0;
  /** アップロード数最大値 */
  uploadCount: number = 0;
  /** プログレス付きローディング表示可否 */
  progressLoading: boolean = false;
  /** プログレス付きローディングメッセージ */
  progressMessage: string = "";

  /** バリデーションアラート表示可否 */
  showValidationAlert: boolean = false;

  /** エラーメッセージ */
  errorMessage: string = "";
  /** ファイルアップロードエラーモーダル表示可否 */
  showUploadErrorModal: boolean = false;

  /** ファイル登録数 */
  readonly registerFileUploadLimit: number = 9;

  get _permissions(): SendDocumentsFunction {
    return userStore.loginUser.permissions.sendDocumentsFunction;
  }

  /** 宛先種別選択肢 */
  get _typeOptions(): Array<{ value: number | string; label: string }> {
    const permissions = this._permissions;
    const options: Array<{ value: number | string; label: string }> = [];
    if (permissions.showTargetToAllFamily == true) {
      options.push({ value: SendMessageTarget.ALL_FAMILIES, label: "家族全員" });
    }
    if (permissions.showTargetToFamily == true) {
      options.push({ value: SendMessageTarget.FAMILIES, label: "家族個別" });
    }
    if (permissions.showTargetToOtherUser == true) {
      options.push({ value: SendMessageTarget.OTHER_USERS, label: "施設関係者個別" });
    }
    if (
      permissions.showTargetToFamilySendMessageGroup == true ||
      permissions.showTargetToOtherUserSendMessageGroup == true ||
      permissions.showTargetToResidentGroup == true ||
      permissions.showTargetToOtherUserGroup == true
    ) {
      options.push({ value: SendMessageTarget.GROUPS, label: "グループ" });
    }
    return options;
  }

  get _showDraft(): boolean {
    return userStore.loginUser.permissions.sendDocumentsFunction.useDraft;
  }

  @Watch("templateId")
  public changeTemplateId(newTemplateId: number): void {
    if (newTemplateId == 0) {
      this.categoryId = null;
      this.title = "";
      this.text = "";
      this.needConfirm = false;
      this.needAgreement = false;
    }

    const selectedTemplate: SendDocumentTemplatesGetModel | undefined = this.templateIdMap.get(newTemplateId);
    if (selectedTemplate == undefined) {
      return;
    }

    this.title = selectedTemplate.title ? selectedTemplate.title : "";
    this.text = selectedTemplate.text ? selectedTemplate.text : "";
    this.needConfirm = selectedTemplate.needConfirm ? selectedTemplate.needConfirm : false;
    this.needAgreement = selectedTemplate.needAgreement ? selectedTemplate.needAgreement : false;

    // 文書種類が「使用しない」になっている場合はnullで補完する
    if (selectedTemplate.categoryId) {
      let exist: boolean = false;
      for (const category of this.categories) {
        if (category.id == selectedTemplate.categoryId && category.enabled == true) {
          exist = true;
          break;
        }
      }
      this.categoryId = exist == true ? selectedTemplate.categoryId : null;
    } else {
      this.categoryId = null;
    }

    return;
  }

  /**
   * ### 宛先種別の変更イベント
   *
   * - 宛先種別が変更されたら文書単位をリセットする
   * - 宛先種別の値を見て、表示する宛先を作成する
   * - 家族全員の場合
   *   - 文書単位の選択肢を変更する
   * - 家族個別の場合
   *   - 宛先候補(家族個別)を表示対象にする
   *   - 文書単位の選択肢を変更する
   * - 施設関係者個別の場合
   *   - 宛先候補(施設関係者個別)を表示対象にする
   *   - 文書単位の選択肢を変更する
   *   - 文書単位を「宛先全員同じ文書」に強制変更する
   * - 宛先グループの場合、宛先候補(宛先グループ)を表示対象にする
   */
  public async changeType(): Promise<void> {
    this.changeUnit();
    this.targets = [];
    switch (this.type) {
      case SendMessageTarget.ALL_FAMILIES: {
        if (this.targetAllFamilies == null) {
          this.isBusy = true;
          this.isSendTargetBusy = true;
          await this.setTargetAllFamilies();
          this.isSendTargetBusy = false;
          this.isBusy = false;
        }
        this.targets = this.createSendTargetAllFamilies(this.targetAllFamilies!, this.residentMapById);
        this.unitOptions = [
          { value: Unit.SAME, label: "宛先全員同じ文書" },
          { value: Unit.SEPARATE, label: "利用者ごとに異なる文書" }
        ];
        break;
      }
      case SendMessageTarget.FAMILIES: {
        if (this.targetFamilies == null) {
          this.isBusy = true;
          this.isSendTargetBusy = true;
          await this.setTargetFamilies();
          this.isSendTargetBusy = false;
          this.isBusy = false;
        }
        this.targets = this.createSendTargetFamilies(this.targetFamilies!, this.residentMapById);
        this.unitOptions = [
          { value: Unit.SAME, label: "宛先全員同じ文書" },
          { value: Unit.SEPARATE, label: "利用者ごとに異なる文書" }
        ];
        break;
      }
      case SendMessageTarget.OTHER_USERS: {
        if (this.targetOtherUsers == null) {
          this.isBusy = true;
          this.isSendTargetBusy = true;
          await this.setTargetOtherUsers();
          this.isSendTargetBusy = false;
          this.isBusy = false;
        }
        this.targets = this.createSendTargetOtherUsers(this.targetOtherUsers!);
        this.unitOptions = [{ value: Unit.SAME, label: "宛先全員同じ文書" }];
        this.unit = Unit.SAME;
        break;
      }
      case SendMessageTarget.GROUPS: {
        if (this.targetGroups == null) {
          this.isBusy = true;
          this.isSendTargetBusy = true;
          await this.setTargetSendMessageGroups();
          this.isSendTargetBusy = false;
          this.isBusy = false;
        }
        this.targets = this.createSendTargetGroups(this.targetGroups!);
        switch (this.groupType) {
          case GroupType.FAMILY:
          case GroupType.RESIDENT_GROUP: {
            this.unitOptions = [
              { value: Unit.SAME, label: "宛先全員同じ文書" },
              { value: Unit.SEPARATE, label: "利用者ごとに異なる文書" }
            ];

            break;
          }
          case GroupType.OTHER_USER:
          case GroupType.OTHER_USER_GROUP: {
            this.unitOptions = [{ value: Unit.SAME, label: "宛先全員同じ文書" }];

            break;
          }
        }
        break;
      }
      default: {
        this.targets = [];
      }
    }

    return;
  }

  /**
   * ### 表示用の宛先(家族全員)を作成する
   *
   * - 画面には表示されないが、データ管理として作成している
   */
  public createSendTargetAllFamilies(targetAllFamilies: Array<FamilyGetModel>, residentMapById: Map<number, ResidentGetModel>): Array<SendTarget> {
    const targets: Array<SendTarget> = [];
    for (const family of targetAllFamilies) {
      const resident: ResidentGetModel | undefined = residentMapById.get(family.id);
      const insuredNumberKey: string | null = resident
        ? resident.insuredNumber && resident.careInsuranceInsuredNumber
          ? `${resident.insuredNumber}_${resident.careInsuranceInsuredNumber}`
          : null
        : null;
      targets.push({
        isTarget: true,
        key: family.residentsSortKey,
        insuredNumberKey: insuredNumberKey,
        label: family.familyName,
        source: family
      });
    }
    return targets;
  }

  /**
   * ### 表示用の宛先(家族個別)を作成する
   */
  public createSendTargetFamilies(targetFamilies: Array<SendTargetResidentGroup>, residentMapById: Map<number, ResidentGetModel>): Array<SendTarget> {
    const targets: Array<SendTarget> = [];
    for (const target of targetFamilies) {
      for (const resident of target.residents) {
        for (const family of resident.families) {
          const resident: ResidentGetModel | undefined = residentMapById.get(family.id);
          const insuredNumberKey: string | null = resident
            ? resident.insuredNumber && resident.careInsuranceInsuredNumber
              ? `${resident.insuredNumber}_${resident.careInsuranceInsuredNumber}`
              : null
            : null;
          targets.push({
            isTarget: family.isTarget,
            key: family.residentsSortKey,
            insuredNumberKey: insuredNumberKey,
            label: family.familyName,
            source: family
          });
        }
      }
    }
    return targets;
  }

  /**
   * ### 表示用の宛先(施設関係者個別)を作成する
   */
  public createSendTargetOtherUsers(targetOtherUsers: Array<OtherUserGroupTypeGroup>): Array<SendTarget> {
    const targets: Array<SendTarget> = [];
    for (const otherUser of targetOtherUsers) {
      for (const member of otherUser.members) {
        targets.push({
          isTarget: member.isTarget,
          key: member.otherUserGroupsSortKey,
          insuredNumberKey: null, // 施設関係者は保険者番号が無いのでnull
          label: member.memberName,
          source: member
        });
      }
    }
    return targets;
  }

  /**
   * ### 表示用の宛先(宛先グループ)を作成する
   */
  public createSendTargetGroups(targetGroups: GroupModel): Array<SendTarget> {
    const targets: Array<SendTarget> = [];
    for (const familyGroup of targetGroups.familyGroups) {
      targets.push({
        isTarget: familyGroup.isTarget,
        key: familyGroup.sendMessageGroupsSortKey,
        insuredNumberKey: null, // ここではnullを格納するが、送信前にグループに所属するユーザーを取得して保険者番号を格納する
        label: familyGroup.name,
        source: familyGroup
      });
    }
    for (const otherUserGroup of targetGroups.otherUserGroupMemberGroups) {
      targets.push({
        isTarget: otherUserGroup.isTarget,
        key: otherUserGroup.sendMessageGroupsSortKey,
        insuredNumberKey: null, // 施設関係者は保険者番号が無いのでnull
        label: otherUserGroup.name,
        source: otherUserGroup
      });
    }
    for (const residentGroup of targetGroups.residentGroups) {
      targets.push({
        isTarget: residentGroup.isTarget,
        key: residentGroup.key,
        insuredNumberKey: null, // 施設関係者は保険者番号が無いのでnull
        label: residentGroup.name,
        source: residentGroup
      });
    }
    for (const otherUserGroup of targetGroups.otherUserGroups) {
      targets.push({
        isTarget: otherUserGroup.isTarget,
        key: otherUserGroup.key,
        insuredNumberKey: null, // 施設関係者は保険者番号が無いのでnull
        label: otherUserGroup.name,
        source: otherUserGroup
      });
    }
    return targets;
  }

  /**
   * ### 文書単位の変更イベント
   *
   * - 文書単位が変更された場合、添付文書をリセットする
   */
  public changeUnit(): void {
    this.unit = null;
    this.sameFiles = [];
    this.separateFileTargets = [];
    this.separateFiles = [];
    return;
  }

  /**
   * ### vue lifecycle created
   */
  public created(): void {
    CustomValidate.addCustomValidate(this.$validator);
    return;
  }

  /**
   * ### vue lifecycle created
   */
  public async mounted(): Promise<void> {
    this.planType = userStore.facility.planType;
    await this.createView();
    return;
  }

  /**
   * ### 画面表示情報を作成する
   *
   * - 利用者グループ名を使用する処理のために利用者グループ情報をMAP化する
   * - 宛先種別に応じた宛先候補を作成する
   *   - 家族全員、家族個別、施設関係者、宛先グループ
   * - 宛先を取得する
   * - 編集画面なので編集対象の文書送付を取得して入力要素に反映させる
   * - 既に文書送付が送信済みの場合、再度送信させてはいけないので404画面へ遷移させる
   */
  public async createView(): Promise<void> {
    this.isBusy = true;
    this.loadingMessage = "読込み中...";

    this.mainId = Number(this.$route.params.id);
    const beforeSendDocument: SendDocumentGetModel = await this.getSendDocument(Number(this.$route.params.id));

    const tempaltes: Array<SendDocumentTemplatesGetModel> = await this.getSendDocumentTemplates();
    const filterdTemplates: Array<SendDocumentTemplatesGetModel> = this.filteringByTemplateType(tempaltes);
    const templateOptions: Array<{ value: number; label: string }> = this.createTemplateOpstions(filterdTemplates);
    this.templateOptions = templateOptions;
    const templateIdMap: Map<number, SendDocumentTemplatesGetModel> = this.createTemplateIdMap(filterdTemplates);
    this.templateIdMap = templateIdMap;

    const residentGroups: Array<ResidentGroupsGetModel> = await this.getResidentGroups();
    const residentGroupMap: Map<number, ResidentGroupsGetModel> = this.createResidentGroupMap(residentGroups);
    this.residentGroupMap = residentGroupMap;

    const residents: Array<ResidentGetModel> = await this.getResidents();
    const residentMapById: Map<number, ResidentGetModel> = this.createResidentMapById(residents);
    this.residentMapById = residentMapById;

    const otherUserGroupMembersInFacility: Array<OtherUserGroup> = await this.otherUserGroupMembersService.get(userStore);
    this.otherUserGroupMembersInFacility = otherUserGroupMembersInFacility;

    const categories: Array<SendDocumentCategoryGetModel> = await this.getSendDocumentCategories();
    this.categories = categories;
    const categoryOptions: Array<{ value: number | string; label: string }> = this.createCategoryOptions(categories);
    this.categoryOptions = categoryOptions;
    const categoryMap: Map<number, string> = this.createCategoryMap(categories);
    this.categoryMap = categoryMap;

    await this.setBeforeSendDocument(beforeSendDocument);

    this.beforeSendDocument = beforeSendDocument;

    // storeに一時保存した入力内容を復元する
    this.restoreScreenInputTemporaryStore();

    this.isBusy = false;

    return;
  }

  /**
   * ### 文書送付テンプレートを取得する
   */
  public async getSendDocumentTemplates(): Promise<Array<SendDocumentTemplatesGetModel>> {
    const records: Array<SendDocumentTemplatesGetModel> = await this.sendDocumentTemplatesService.gets(userStore);
    return records;
  }

  /**
   * ### 文書送付テンプレートをテンプレート種別でフィルタリングする
   *
   * - テンプレート種別が「家族連絡サービス」のもののみ返却する
   */
  public filteringByTemplateType(templates: Array<SendDocumentTemplatesGetModel>): Array<SendDocumentTemplatesGetModel> {
    return templates.concat().filter((temaplte) => {
      return temaplte.templateType == TemplateType.FAMILY_SERVICE ? true : false;
    });
  }

  /**
   * ### メッセージ送信テンプレートの選択肢を作成する
   */
  public createTemplateOpstions(templates: Array<SendDocumentTemplatesGetModel>): Array<{ value: number; label: string }> {
    let options: Array<{ value: number; label: string }> = [];
    options.push({ value: 0, label: `使用しない` });
    for (const template of templates) {
      options.push({ value: template.id, label: template.name });
    }
    return options;
  }

  /**
   * ### テンプレートIDのMAPを作成する
   */
  public createTemplateIdMap(templates: Array<SendDocumentTemplatesGetModel>): Map<number, SendDocumentTemplatesGetModel> {
    let map: Map<number, SendDocumentTemplatesGetModel> = new Map<number, SendDocumentTemplatesGetModel>();
    for (const template of templates) {
      map.set(template.id, template);
    }
    return map;
  }

  /**
   * ### 利用者グループを取得する
   */
  public async getResidentGroups(): Promise<Array<ResidentGroupsGetModel>> {
    const response: Array<ResidentGroupsGetModel> = await this.residentGroupsService.gets(userStore);
    return response;
  }

  /**
   * ### 利用者グループMAPを作成する
   *
   * - key：グループID
   * - value：グループ情報
   */
  public createResidentGroupMap(groups: Array<ResidentGroupsGetModel>): Map<number, ResidentGroupsGetModel> {
    let map: Map<number, ResidentGroupsGetModel> = new Map<number, ResidentGroupsGetModel>();
    for (const group of groups) {
      map.set(group.id, group);
    }
    return map;
  }

  /**
   * ### 文書送付カテゴリーを取得する
   */
  public async getSendDocumentCategories(): Promise<Array<SendDocumentCategoryGetModel>> {
    const response: Array<SendDocumentCategoryGetModel> = await this.categoriesService.gets(userStore);
    return response;
  }

  /**
   * ### 文書送付カテゴリーの選択肢を作成する
   */
  public createCategoryOptions(categories: Array<SendDocumentCategoryGetModel>): Array<{ value: number | string; label: string }> {
    const options: Array<{ value: number | string; label: string }> = [];
    for (const category of categories) {
      if (category.enabled == true) {
        options.push({
          value: category.id,
          label: category.name
        });
      }
    }
    return options;
  }

  /**
   * ### IDから名称変換用にカテゴリのMAPを作成する
   */
  public createCategoryMap(categories: Array<SendDocumentCategoryGetModel>): Map<number, string> {
    const map: Map<number, string> = new Map<number, string>();
    for (const category of categories) {
      map.set(category.id, category.name);
    }
    return map;
  }

  /**
   * ### 保険番号を家族に付与するために利用者を取得する
   */
  public async getResidents(): Promise<Array<ResidentGetModel>> {
    const response: Array<ResidentGetModel> = await this.residentsService.gets(userStore);
    return response;
  }

  /**
   * ### 利用者IDをkeyに利用者MAPを作成する
   */
  public createResidentMapById(residents: Array<ResidentGetModel>): Map<number, ResidentGetModel> {
    const residentMapById: Map<number, ResidentGetModel> = new Map<number, ResidentGetModel>();
    for (const resident of residents) {
      residentMapById.set(resident.id, resident);
    }
    return residentMapById;
  }

  /**
   * ### 宛先の家族全員の場合の宛先を取得する
   */
  public async setTargetAllFamilies(): Promise<void> {
    const families: Array<FamilyGetModel> = await this.getNonmaskedFamilies();
    for (let family of families) {
      const resident: ResidentGetModel | undefined = this.residentMapById.get(family.id);
      family.insuredNumber = resident ? (resident.insuredNumber ? resident.insuredNumber : null) : null;
      family.careInsuranceInsuredNumber = resident ? (resident.careInsuranceInsuredNumber ? resident.careInsuranceInsuredNumber : null) : null;
    }
    this.targetAllFamilies = families;
    return;
  }

  /**
   * ### 宛先で選択候補とする家族を取得する
   */
  public async getNonmaskedFamilies(): Promise<Array<FamilyGetModel>> {
    let response: Array<FamilyGetModel> = [];

    try {
      const params: any = {
        masking: "none"
      };
      response = await this.familiesService.getsInFacility(userStore, params);
    } catch (error) {
      const systemerror: SystemError = error as SystemError;
      // 413エラーの場合、全件取得した結果がペイロード制限に引っかかったことになるので、index指定で段階的に取得する
      if (systemerror.statusCode == 413) {
        const count: number = await this.familiesService.getCountInFacility(userStore);
        const loopEnd: number = Math.ceil(count / 300);

        for (let i = 0; i < loopEnd; i++) {
          const params: any = {
            startIndex: i * 300,
            endIndex: i * 300 + 300,
            masking: "none"
          };
          response = response.concat(await this.familiesService.getsInFacility(userStore, params));
        }
      }
    }
    return response.filter((family) => {
      if (family.status == ResidentStatus.RESIDENT) {
        return true;
      } else {
        return false;
      }
    });
  }

  /**
   * ### 宛先候補の家族情報を格納する
   *
   * - 家族の宛先選択では利用者グループ－利用者－家族の階層構造なので階層構造を作る
   * - LINEユーザーのみに絞り込む
   */
  public async setTargetFamilies(): Promise<void> {
    const families: Array<FamilyGetModel> = await this.getMaskedFamilies();

    let residentMap: Map<number, SendTargetResident> = new Map<number, SendTargetResident>();
    for (const family of families) {
      const residentId: number = family.id;
      let sendTargetResident: SendTargetResident | undefined = residentMap.get(residentId);

      // TODO 暫定処理 家族にgroupIdが格納されていない場合があるので、親利用者を取得してgropuId、insuredNumberを格納する
      const resident: ResidentGetModel | undefined = this.residentMapById.get(family.id);
      family.groupId = resident ? resident.groupId : family.groupId;
      family.insuredNumber = resident ? (resident.insuredNumber ? resident.insuredNumber : null) : null;
      family.careInsuranceInsuredNumber = resident ? (resident.careInsuranceInsuredNumber ? resident.careInsuranceInsuredNumber : null) : null;

      if (sendTargetResident == undefined) {
        const newSendTargetResident: SendTargetResident = {
          ...family,
          show: true,
          families: [{ ...family, isTarget: false, show: true }]
        };
        residentMap.set(residentId, newSendTargetResident);
      } else {
        sendTargetResident.families.push({ ...family, isTarget: false, show: true });
        residentMap.set(residentId, sendTargetResident);
      }
    }

    let residentGroupMap: Map<number, SendTargetResidentGroup> = new Map<number, SendTargetResidentGroup>();
    const residentGroups: Array<ResidentGroupsGetModel> = await this.getResidentGroups();
    for (const residentGroup of residentGroups) {
      residentGroupMap.set(residentGroup.id, { ...residentGroup, residents: [], show: true });
    }

    const sendTargetResidents: Array<SendTargetResident> = this.mapToArray(residentMap);
    for (const sendTargetResident of sendTargetResidents) {
      const residentGroupId: number = sendTargetResident.groupId;
      const residentGroup: SendTargetResidentGroup | undefined = residentGroupMap.get(residentGroupId);
      if (residentGroup != undefined) {
        residentGroup.residents.push(sendTargetResident);
      }
    }

    const targetFamilies: Array<SendTargetResidentGroup> = [];
    for (const group of this.mapToArray(residentGroupMap)) {
      targetFamilies.push(group);
    }
    this.targetFamilies = targetFamilies;

    return;
  }

  /**
   * ### 宛先で選択候補とする家族を取得する
   */
  public async getMaskedFamilies(): Promise<Array<FamilyGetModel>> {
    let response: Array<FamilyGetModel> = [];

    try {
      response = await this.familiesService.getsInFacility(userStore);
    } catch (error) {
      const systemerror: SystemError = error as SystemError;
      // 413エラーの場合、全件取得した結果がペイロード制限に引っかかったことになるので、index指定で段階的に取得する
      if (systemerror.statusCode == 413) {
        const pagePerCount: number = 50;
        const count: number = await this.familiesService.getCountInFacility(userStore);
        const loopEnd: number = Math.ceil(count / pagePerCount);

        for (let i = 0; i < loopEnd; i++) {
          const params: any = {
            startIndex: i * pagePerCount,
            endIndex: i * pagePerCount + pagePerCount
          };
          response = response.concat(await this.familiesService.getsInFacility(userStore, params));
        }
      }
    }
    return response;
  }

  /**
   * ### 宛先候補の施設関係者メンバーを格納する
   *
   * - 施設関係者の宛先選択では施設関係者グループ－施設関係者メンバーの階層構造なので階層構造を作る
   * - 施設関係者メンバーはLINEユーザーのみに絞り込む
   */
  public async setTargetOtherUsers(): Promise<void> {
    const groups: Array<OtherUserGroupTypeGroup> = await this.getOtherUserGroupMembers();

    const otherUserGroupTypes: Array<OtherUserGroupTypeModel> = await this.getOtherGroupTypes();
    const otherUserGroupTypesMap: Map<number, string> = this.createOtherUserGroupTypesMap(otherUserGroupTypes);
    for (const group of groups) {
      const groupTypeName: string | undefined = otherUserGroupTypesMap.get(group.groupTypeId);
      group.groupName = groupTypeName ? groupTypeName : "";
      group.show = true;

      const members: Array<OtherUserGroupTypeMember> = [];
      for (let member of group.members) {
        members.push({
          ...member,
          groupTypeName: group.groupName,
          show: true,
          isTarget: false
        });
      }
      group.members = members;
    }

    this.targetOtherUsers = groups;
    this.otherUserGroupTypesMap = otherUserGroupTypesMap;

    return;
  }

  /**
   * ### 施設関係者グループ種類にひもづくメンバーを取得する
   */
  public async getOtherUserGroupMembers(): Promise<Array<OtherUserGroupTypeGroup>> {
    const response: Array<OtherUserGroupTypeGroup> = await this.otherUserGroupTypeMembersService.get(userStore, -1);
    return response;
  }

  /**
   * ### 施設関係者グループ種類を取得する
   */
  public async getOtherGroupTypes(): Promise<Array<OtherUserGroupTypeModel>> {
    const otherUserGroupTypes: Array<OtherUserGroupTypeModel> = await this.otherUserGroupTypesService.get(userStore);
    return otherUserGroupTypes;
  }

  /**
   * ### 施設関係者グループ種類のMAPを作成する
   */
  public createOtherUserGroupTypesMap(otherUserGroupTypes: Array<OtherUserGroupTypeModel>): Map<number, string> {
    const map: Map<number, string> = new Map<number, string>();
    for (const type of otherUserGroupTypes) {
      map.set(type.id, type.name);
    }
    return map;
  }

  /**
   * ### 宛先候補の宛先グループを格納する
   *
   * - 施設関係者の宛先選択では施設関係者グループ－施設関係者メンバーの階層構造なので階層構造を作る
   */
  public async setTargetSendMessageGroups(): Promise<void> {
    if (this.targetAllFamilies == null) {
      await this.setTargetAllFamilies();
    }
    const allFamily: Array<FamilyGetModel> = this.targetAllFamilies!;
    const residentGroups: Array<ResidentGroupsGetModel> = await this.getResidentGroups();
    const sendMessageGroups: Array<SendMessageGroupsGetModel> = await this.sendMessageGroupsService.gets(userStore);
    const otherUserGroups: Array<OtherUserGroup> = await this.otherUserGroupsService.gets(userStore);
    const otherUserGroupMembersInFacility: Array<OtherUserGroup> = await this.otherUserGroupMembersService.get(userStore);

    const sendMessageGroupModel: GroupModel = {
      familyGroups: [],
      otherUserGroupMemberGroups: [],
      residentGroups: [],
      otherUserGroups: []
    };
    // 宛先グループの情報作成
    for (const group of sendMessageGroups) {
      const targetSendMessageGroup: SendTargetSendMessageGroup = {
        isTarget: false,
        ...group
      };

      if (targetSendMessageGroup.type == GroupType.FAMILY) {
        sendMessageGroupModel.familyGroups.push({
          ...targetSendMessageGroup,
          show: true,
          memberCount: group.members.length
        });
      } else if (targetSendMessageGroup.type == GroupType.OTHER_USER) {
        sendMessageGroupModel.otherUserGroupMemberGroups.push({
          ...targetSendMessageGroup,
          show: true,
          memberCount: group.members.length
        });
      }
    }
    // 利用者グループの情報を作成
    // 利用者グループは人数をTBLに持っていないので、MAPを作って集計する
    const residentGroupMemberCountMap = new Map<number, number>();
    for (const family of allFamily) {
      let memberCount: number | undefined = residentGroupMemberCountMap.get(family.groupId);
      if (memberCount) {
        memberCount++;
        residentGroupMemberCountMap.set(family.groupId, memberCount);
      } else {
        residentGroupMemberCountMap.set(family.groupId, 1);
      }
    }
    for (const group of residentGroups) {
      const _group: ResidentGroupTargetModel = Object.assign({}, group) as ResidentGroupTargetModel;
      _group.isTarget = false;
      const memberCount: number | undefined = residentGroupMemberCountMap.get(_group.id);
      _group.memberCount = memberCount ? memberCount : 0;
      sendMessageGroupModel.residentGroups.push({
        ..._group,
        key: `residentGroup_${_group.id}`,
        show: true
      });
    }
    // 施設関係者グループの情報を作成
    // 施設関係者グループは人数をTBLに持っていないので、MAPを作って集計する
    const otherUserGroupMemberCountMap = new Map<number, number>();
    for (const member of otherUserGroupMembersInFacility) {
      let memberCount: number | undefined = otherUserGroupMemberCountMap.get(member.id);
      if (memberCount) {
        memberCount++;
        otherUserGroupMemberCountMap.set(member.id, memberCount);
      } else {
        otherUserGroupMemberCountMap.set(member.id, 1);
      }
    }
    for (const group of otherUserGroups) {
      const _group: OtherUserGroupTargetModel = Object.assign({}, group) as OtherUserGroupTargetModel;
      _group.isTarget = false;
      const memberCount: number | undefined = otherUserGroupMemberCountMap.get(_group.id);
      _group.memberCount = memberCount ? memberCount : 0;
      sendMessageGroupModel.otherUserGroups.push({
        ..._group,
        key: `otherUserGroup_${_group.id}`,
        show: true
      });
    }

    this.targetGroups = sendMessageGroupModel;
    return;
  }

  /**
   * ### 文書送付を取得する
   */
  public async getSendDocument(id: number): Promise<SendDocumentGetModel> {
    const response: Array<SendDocumentGetModel> = await this.sendDocumentsService.get(userStore, id);
    for (const sendDocument of response) {
      if (sendDocument.mainId == id) {
        return sendDocument;
      }
    }
    return response[0];
  }

  /**
   * ### 編集前の文書送付情報を格納する
   *
   * - 種別を文書送付情報から復元する
   * - 種別がnull以外であれば、種別に応じて宛先を復元する
   * - 文書単位を文書送付情報から復元する
   * - 文書単位がnull以外であれば、種別に応じてファイルを復元する
   * - タイトル、本文、確認しましたボタン、同意しましたボタンを文書送付情報から復元する
   * - ファイル情報は最終的にアップロードしなおすので空配列にする
   */
  public async setBeforeSendDocument(sendDocument: SendDocumentGetModel): Promise<void> {
    this.isPublic = sendDocument.isPublic;
    const typeAndGroupType = this.restoreTypeAndGroupType(sendDocument);
    this.type = typeAndGroupType.type;
    this.groupType = typeAndGroupType.groupType;

    if (sendDocument.type != null) {
      await this.changeType();

      switch (sendDocument.type) {
        case Type.SELECTED_FAMILY: {
          const sortKeyMap: Map<string, string> = new Map<string, string>();
          for (const receiver of (sendDocument.receivers as Array<SendDocumentFamilyReceiver>) || []) {
            sortKeyMap.set(receiver.residentsSortKey, receiver.residentsSortKey);
          }
          for (const target of this.targets) {
            const key: string | undefined = sortKeyMap.get(target.key);
            target.isTarget = key != undefined ? true : false;
          }
          if (this.targetFamilies != null) {
            for (const group of this.targetFamilies) {
              for (const resident of group.residents) {
                for (const family of resident.families) {
                  family.isTarget = sortKeyMap.has(family.residentsSortKey);
                }
              }
            }
          }
          break;
        }
        case Type.SELECTED_OTHER_USER: {
          const sortKeyMap: Map<string, string> = new Map<string, string>();
          for (const receiver of (sendDocument.receivers as Array<SendDocumentOtherUserReceiver>) || []) {
            sortKeyMap.set(receiver.otherUserGroupsSortKey, receiver.otherUserGroupsSortKey);
          }
          for (const target of this.targets) {
            const key: string | undefined = sortKeyMap.get(target.key);
            target.isTarget = key != undefined ? true : false;
          }
          if (this.targetOtherUsers != null) {
            for (const group of this.targetOtherUsers) {
              for (const member of group.members) {
                member.isTarget = sortKeyMap.has(member.otherUserGroupsSortKey);
              }
            }
          }
          break;
        }
        case Type.SEND_MESSAGE_GROUP: {
          const sendMessageGroupInfos: Array<SendMessageGroupInfo> = (sendDocument.sendMessageGroupInfos as Array<SendMessageGroupInfo>) || [];
          const sendMessageGroupSortKeyMap: Map<string, string> = new Map<string, string>();
          for (const sendMessageGroupInfo of sendMessageGroupInfos) {
            sendMessageGroupSortKeyMap.set(sendMessageGroupInfo.sendMessageGroupsSortKey, sendMessageGroupInfo.sendMessageGroupsSortKey);
          }
          for (const target of this.targets) {
            const key: string | undefined = sendMessageGroupSortKeyMap.get(target.key);
            target.isTarget = key != undefined ? true : false;
          }
          if (this.targetGroups != null) {
            for (const familyGroup of this.targetGroups.familyGroups) {
              familyGroup.isTarget = sendMessageGroupSortKeyMap.has(familyGroup.sendMessageGroupsSortKey);
            }
            for (const otherUserGroup of this.targetGroups.otherUserGroupMemberGroups) {
              otherUserGroup.isTarget = sendMessageGroupSortKeyMap.has(otherUserGroup.sendMessageGroupsSortKey);
            }
          }
          break;
        }
        case Type.RESIDENT_GROUP: {
          const residentGroupInfos: Array<ResidentGroupInfo> = (sendDocument.residentGroupInfos as Array<ResidentGroupInfo>) || [];
          const residentGroupKeyMap: Map<string, string> = new Map<string, string>();
          for (const residentGroupInfo of residentGroupInfos) {
            residentGroupKeyMap.set(`residentGroup_${residentGroupInfo.id}`, `residentGroup_${residentGroupInfo.id}`);
          }
          for (const target of this.targets) {
            const key: string | undefined = residentGroupKeyMap.get(target.key);
            target.isTarget = key != undefined ? true : false;
          }
          if (this.targetGroups != null) {
            for (const residentGroup of this.targetGroups.residentGroups) {
              residentGroup.isTarget = residentGroupKeyMap.has(residentGroup.key);
            }
          }
          break;
        }
        case Type.OTHER_USER_GROUP: {
          const otherUserGroupInfos: Array<GroupOtherUserGroupInfo> = (sendDocument.otherUserGroupInfos as Array<GroupOtherUserGroupInfo>) || [];
          const otherUserGroupKeyMap: Map<string, string> = new Map<string, string>();
          for (const otherUserGroupInfo of otherUserGroupInfos) {
            otherUserGroupKeyMap.set(`otherUserGroup_${otherUserGroupInfo.id}`, `otherUserGroup_${otherUserGroupInfo.id}`);
          }
          for (const target of this.targets) {
            const key: string | undefined = otherUserGroupKeyMap.get(target.key);
            target.isTarget = key != undefined ? true : false;
          }
          if (this.targetGroups != null) {
            for (const otherUserGroup of this.targetGroups.otherUserGroups) {
              otherUserGroup.isTarget = otherUserGroupKeyMap.has(otherUserGroup.key);
            }
          }
          break;
        }
      }
    }

    this.unit = sendDocument.unit;
    // 文書単位が選択されていなければファイルは初期値
    if (sendDocument.unit == null) {
      this.sameFiles = [];
      this.separateFiles = [];
    }
    // 同じ文書の場合のファイル復元
    // 未送信／送信済み共通
    else if (sendDocument.unit == Unit.SAME) {
      let files: Array<File> = [];
      for (const sameFiles of sendDocument.fileUrls) {
        if (sameFiles.sortKey != "none") {
          continue;
        }
        for (let i = 0; i < sameFiles.files.length; i++) {
          const file = sameFiles.files[i];
          // anyにして、Fileとして扱う。 プレビュー時にurlがあればS3から取得してFileを作る
          const _file = { name: file.name, url: file.url, key: `${file.name}_${i}`, type: "application/pdf" };
          files.push(_file as any);
        }
      }

      this.sameFiles = files;
      this.separateFiles = [];
      this.separateFileTargets = [];
    }
    // 異なる文書の場合のファイル復元
    // 未送信／送信済みで一部分岐処理する
    else if (sendDocument.unit == Unit.SEPARATE) {
      const separateFiles: Array<ResidentSeparateFiles> = [];
      const separateFileTargets: Array<SendTargetExtFiles> = [];
      for (const separateFile of sendDocument.fileUrls) {
        const files: Array<File> = [];
        for (let i = 0; i < separateFile.files.length; i++) {
          const file = separateFile.files[i];
          // anyにして、Fileとして扱う。 プレビュー時にurlがあればS3から取得してFileを作る
          const _file = { name: file.name, url: file.url, key: `${file.name}_${i}`, type: "application/pdf" };
          files.push(_file as any);
        }
        separateFiles.push({
          sortKey: separateFile.sortKey,
          files: files
        });
      }

      const sortKeyFilesMap: Map<string, Array<File>> = new Map<string, Array<File>>();
      for (const files of separateFiles) {
        sortKeyFilesMap.set(files.sortKey, files.files);
      }

      switch (this.type) {
        case SendMessageTarget.ALL_FAMILIES:
        case SendMessageTarget.FAMILIES: {
          // 未送信
          if (!sendDocument.isSended) {
            for (const target of this.targets) {
              const files: Array<File> | undefined = sortKeyFilesMap.get(target.key);
              separateFileTargets.push({
                ...target,
                files: files != undefined ? files : []
              });
            }
          }
          // 送信済み（送信済みの場合は送信していないユーザーをファイルリストモーダルに表示したくないのでrecerivers基準に情報作成）
          else {
            for (const receiver of sendDocument.receivers as Array<SendDocumentFamilyReceiver>) {
              const files: Array<File> | undefined = sortKeyFilesMap.get(receiver.residentsSortKey as string);
              separateFileTargets.push({
                isTarget: true,
                key: receiver.residentsSortKey,
                insuredNumberKey: null,
                label: receiver.familyName,
                files: files != undefined ? files : [],
                source: receiver
              });
            }
          }
          break;
        }
        case SendMessageTarget.GROUPS: {
          // 未送信
          if (!sendDocument.isSended) {
            this.loadingMessage = "読込み中...";
            this.isBusy = true;
            switch (this.groupType) {
              case GroupType.FAMILY: {
                for (const target of this.targets) {
                  if (target.isTarget == true) {
                    const source: SendMessageGroupTargetModel = target.source as SendMessageGroupTargetModel;
                    const families: Array<SendMessageGroupMembersFamilyGetModel> = await this.getSendMessageGroupFamilyMembers(source.id);

                    for (const family of families) {
                      const resident: ResidentGetModel | undefined = this.residentMapById.get(family.id);
                      const insuredNumberKey: string | null = resident
                        ? resident.insuredNumber && resident.careInsuranceInsuredNumber
                          ? `${resident.insuredNumber}_${resident.careInsuranceInsuredNumber}`
                          : null
                        : null;
                      const files: Array<File> | undefined = sortKeyFilesMap.get(family.residentsSortKey as string);
                      separateFileTargets.push({
                        isTarget: true,
                        key: family.residentsSortKey as string,
                        insuredNumberKey: insuredNumberKey,
                        label: family.familyName as string,
                        source: family,
                        files: files != undefined ? files : []
                      });
                    }
                  }
                }
                break;
              }
              case GroupType.RESIDENT_GROUP: {
                for (const target of this.targets) {
                  if (target.isTarget == true) {
                    const source: ResidentGroupTargetModel = target.source as ResidentGroupTargetModel;
                    if (this.targetAllFamilies != null) {
                      for (const family of this.targetAllFamilies) {
                        if (family.groupId != source.id) {
                          continue;
                        }
                        const resident: ResidentGetModel | undefined = this.residentMapById.get(family.id);
                        const insuredNumberKey: string | null = resident
                          ? resident.insuredNumber && resident.careInsuranceInsuredNumber
                            ? `${resident.insuredNumber}_${resident.careInsuranceInsuredNumber}`
                            : null
                          : null;
                        const files: Array<File> | undefined = sortKeyFilesMap.get(family.residentsSortKey as string);
                        separateFileTargets.push({
                          isTarget: true,
                          key: family.residentsSortKey as string,
                          insuredNumberKey: insuredNumberKey,
                          label: family.familyName as string,
                          source: family,
                          files: files != undefined ? files : []
                        });
                      }
                    }
                  }
                }
                break;
              }
            }
            this.isBusy = false;
          }
          // 送信済み（送信済みの場合は送信していないユーザーをファイルリストモーダルに表示したくないのでrecerivers基準に情報作成）
          else {
            for (const receiver of sendDocument.receivers as Array<SendDocumentFamilyReceiver>) {
              const files: Array<File> | undefined = sortKeyFilesMap.get(receiver.residentsSortKey);
              separateFileTargets.push({
                isTarget: true,
                key: receiver.residentsSortKey,
                insuredNumberKey: null,
                label: receiver.familyName,
                files: files != undefined ? files : [],
                source: receiver
              });
            }
          }
          break;
        }
      }

      this.sameFiles = [];
      this.separateFiles = separateFiles;
      this.separateFileTargets = separateFileTargets;
    }
    this.fileUrls = sendDocument.fileUrls;

    this.categoryId = sendDocument.categoryId;
    this.title = sendDocument.title;
    this.text = sendDocument.text;
    this.needConfirm = sendDocument.needConfirm;
    this.needAgreement = sendDocument.needAgreement;

    this.updated = sendDocument.updated;

    return;
  }

  private restoreTypeAndGroupType(sendDocument: SendDocumentGetModel): { type: SendMessageTarget | null; groupType: GroupType } {
    switch (sendDocument.type) {
      case Type.ALL_FAMILY: {
        return { type: SendMessageTarget.ALL_FAMILIES, groupType: GroupType.UNKNOWN };
      }
      case Type.SELECTED_FAMILY: {
        return { type: SendMessageTarget.FAMILIES, groupType: GroupType.UNKNOWN };
      }
      case Type.SELECTED_OTHER_USER: {
        return { type: SendMessageTarget.OTHER_USERS, groupType: GroupType.UNKNOWN };
      }
      case Type.SEND_MESSAGE_GROUP: {
        if (sendDocument.sendMessageGroupInfos && 0 < sendDocument.sendMessageGroupInfos.length) {
          if (sendDocument.sendMessageGroupInfos[0].type == GroupType.FAMILY) {
            return { type: SendMessageTarget.GROUPS, groupType: GroupType.FAMILY };
          } else {
            return { type: SendMessageTarget.GROUPS, groupType: GroupType.OTHER_USER };
          }
        }
        break;
      }
      case Type.RESIDENT_GROUP: {
        return { type: SendMessageTarget.GROUPS, groupType: GroupType.RESIDENT_GROUP };
      }
      case Type.OTHER_USER_GROUP: {
        return { type: SendMessageTarget.GROUPS, groupType: GroupType.OTHER_USER_GROUP };
      }
    }
    return { type: null, groupType: GroupType.UNKNOWN };
  }

  /**
   * ### S3に格納されているFileを取得する
   *
   * @param url 元URL
   */
  public async getS3File(url: string, fileName: string): Promise<File> {
    const response: File = await this.s3UrlService.getFile(userStore, Setting.backets.imageExpireHour, url, fileName);
    return response;
  }

  /**
   * ### 一時保存確認モーダルを表示する
   */
  public showSaveDraftModal(): void {
    if (this.beforeSendDocument != null && this.beforeSendDocument.isSended == false) {
      this.updateModalMessage = "文書送付情報を一時保存しますか？";
    } else {
      this.updateModalMessage = "文書送付情報を更新しますか？";
    }
    this.showUpdateModal = true;
    return;
  }

  /**
   * ### 文書送付を更新する
   */
  public async updateSendDocument(): Promise<void> {
    // nonsended
    if (this.beforeSendDocument != null && this.beforeSendDocument.isSended == false) {
      this.loadingMessage = "一時保存中...";
    }
    // sended
    else {
      this.loadingMessage = "更新中...";
    }
    this.isBusy = true;

    this.setScreenInputTemporaryStore(); // APIリクエスト前にstoreに値を保持する

    try {
      let fileUrls: Array<FileUrl> = [];
      // ファイルアップロードするタイミングでファイルが削除（移動含む）、リネームされた場合は失敗するのでここでtry-catchする
      // アップロードに失敗した場合は添付されたファイルを全てリセットしてモーダルで再添付を促す
      try {
        // 未送信の下書き保存
        if (this.beforeSendDocument != null && this.beforeSendDocument.isSended == false) {
          // 文書単位が「宛先全員同じ文書」の場合の添付文書S3アップロード
          if (this.unit != null && this.unit == Unit.SAME && 0 < this.sameFiles.length) {
            const files: Array<SendDocumentFile> = await this.uploadSameFiles(this.sameFiles);
            fileUrls = [{ sortKey: "none", files: files }];
          }
          // 文書単位が「利用者ごとに異なる文書」の場合の添付文書S3アップロード
          else if (this.unit != null && this.unit == Unit.SEPARATE && 0 < this.separateFiles.length) {
            fileUrls = await this.uploadSeparateFiles(this.separateFiles);
          }
        }
        // 送信済みの下書き保存
        else {
          fileUrls = this.fileUrls;
        }
      } catch (error) {
        this.isBusy = false;

        this.showUploadErrorModal = true;
        this.resetSameFiles();
        this.resetSeparateFiles();

        return;
      }

      const requestBody: SendDocumentPatchModel = await this.createSendDocumentRequestBody(fileUrls, this.type, this.targets, "save");
      await this.sendDocumentsService.patch(userStore, this.mainId as number, requestBody);

      // nonsended
      if (this.beforeSendDocument != null && this.beforeSendDocument.isSended == false) {
        this.updateSuccessModalMessage = "一時保存に成功しました。";
      }
      // sended
      else {
        this.updateSuccessModalMessage = "更新に成功しました。";
      }
      this.resetScreenInputTemporaryStore();

      this.showUpdateSuccessModal = true;
    } catch (error) {
      const systemError: SystemError = error as SystemError;
      // ステータスコードが409の場合、他端末にて更新が行われているので、画面情報を再取得してから再入力を促す
      if (systemError.statusCode == 409) {
        await this.createView();
        this.errorMessage = "他の端末で更新されたか、表示している情報が古いために更新できませんでした。情報を再読み込みして、もう一度お試しください。";
      }
      // その他のステータスコードの場合は上位に例外を投げなおす
      else {
        throw error;
      }
    } finally {
      this.isBusy = false;
    }

    return;
  }

  resetSameFiles(): void {
    this.sameFiles = [];
    return;
  }

  resetSeparateFiles(): void {
    this.separateFiles = [];
    return;
  }

  /**
   * ### 文書単位が「宛先全員同じ文書」の場合の添付文書S3アップロード
   */
  public async uploadSameFiles(files: Array<File>): Promise<Array<SendDocumentFile>> {
    const sendDocumentFiles: Array<SendDocumentFile> = [];

    try {
      const newSameFiles: File[] = [];
      for (const file of files) {
        const _file: any = file;
        // 一時保存されていたファイルの場合、初期処理でFileオブジェクトではなく、nameとurlのObject型のデータを格納している
        // urlがある場合はS3からファイルをダウンロードし、Fileオブジェクトに変換する
        if (_file.url != null) {
          const updatedFile: File = await this.getS3File(_file.url, _file.name);
          newSameFiles.push(updatedFile);
        } else {
          newSameFiles.push(file);
        }
      }
      // S3からファイル取得したものも含めて、sameFilesを更新する
      files = newSameFiles;

      const s3UploadUrls: S3UploadResponse = await this.createSameUploadUrls(files);
      // プログレス付きモーダルを表示する
      // 進捗はファイルのアプロード状況を反映させるようにする
      this.currentUploadCount = 0;
      this.uploadCount = files.length;
      this.progressMessage = "ファイルアップロード中。\n完了するまでそのままお待ちください。\nメッセージ送信中に別画面に遷移しますと処理がキャンセルされます。";
      this.progressLoading = true;

      // アップロード
      const sameFileS3Urls: Array<{ url: string; fields: { [key: string]: string } }> = s3UploadUrls["none"];
      for (let i = 0; i < sameFileS3Urls.length; i++) {
        this.currentUploadCount = i;
        await this.s3UploadsService.uploadFile(sameFileS3Urls[i], files[i]);

        // DBにはファイルではなく、添付ファイルのS3URLを保持するためURL配列を作成する
        const preUrl: string = sameFileS3Urls[i].url.endsWith("/") ? sameFileS3Urls[i].url : `${sameFileS3Urls[i].url}/`;
        const s3Url: string = `${preUrl}${sameFileS3Urls[i].fields["key"]}`;

        sendDocumentFiles.push({
          url: s3Url,
          name: files[i].name
        });
      }
    } finally {
      this.progressLoading = false;
    }

    return sendDocumentFiles;
  }

  /**
   * ### ファイルアップロード先のURLを発行する
   */
  public async createSameUploadUrls(files: Array<File>): Promise<S3UploadResponse> {
    let extensions: Array<string> = [];

    for (const file of files) {
      const _file: Array<string> = file.name.split("/");
      const _extensions: Array<string> = _file[_file.length - 1].split(".");
      extensions.push("." + _extensions[_extensions.length - 1]);
    }

    const params: S3UploadSendDocument = {
      unit: Unit.SAME,
      type: Type.UNKNOWN,
      files: [
        {
          // 以下は「宛先全員同じ文書」なので、使用されないので仮値
          sortKey: "none",
          count: files.length,
          extensions: extensions
        }
      ]
    };
    const requestBody: S3MultiLocation = {
      type: S3UploadType.SEND_DOCUMENT,
      params: params,
      acl: "public-read"
    };
    const urls: S3UploadResponse = await this.s3LocationsService.multiPost(userStore, requestBody);

    return urls;
  }

  /**
   * ### 文書単位が「利用者ごとに異なる文書」の場合の添付文書S3アップロード
   */
  public async uploadSeparateFiles(separatefiles: Array<ResidentSeparateFiles>): Promise<Array<FileUrl>> {
    const fileUrls: Array<FileUrl> = [];

    try {
      for (const separatefile of separatefiles) {
        const newSeparateFiles: File[] = [];
        for (const file of separatefile.files) {
          const _file: any = file;
          // 一時保存されていたファイルの場合、初期処理でFileオブジェクトではなく、nameとurlのObject型のデータを格納している
          // urlがある場合はS3からファイルをダウンロードし、Fileオブジェクトに変換する
          if (_file.url != null) {
            const updatedFile: File = await this.getS3File(_file.url, _file.name);
            newSeparateFiles.push(updatedFile);
          } else {
            newSeparateFiles.push(file);
          }
        }
        // S3からファイル取得したものも含めて、separateFilesを更新する
        separatefile.files = newSeparateFiles;
      }

      const s3UploadUrls: S3UploadResponse = await this.createSeparateUploadUrls(separatefiles);

      let fileCount: number = 0;
      for (const file of separatefiles) {
        fileCount += file.files.length;
      }

      // プログレス付きモーダルを表示する
      // 進捗はファイルのアプロード状況を反映させるようにする
      this.currentUploadCount = 0;
      this.uploadCount = fileCount;
      this.progressMessage = "ファイルアップロード中。\n完了するまでそのままお待ちください。\nメッセージ送信中に別画面に遷移しますと処理がキャンセルされます。";
      this.progressLoading = true;

      // アップロード
      for (const separateFile of separatefiles) {
        const uploadFiles: Array<S3UploadResponseFile> = s3UploadUrls[separateFile.sortKey];

        let files: Array<SendDocumentFile> = [];
        for (let i = 0; i < uploadFiles.length; i++) {
          this.currentUploadCount++;
          await this.s3UploadsService.uploadFile(uploadFiles[i], separateFile.files[i]);

          // DBにはファイルではなく、添付ファイルのS3URLを保持するためURL配列を作成する
          const preUrl: string = uploadFiles[i].url.endsWith("/") ? uploadFiles[i].url : `${uploadFiles[i].url}/`;
          const s3Url: string = `${preUrl}${uploadFiles[i].fields["key"]}`;

          files.push({
            url: s3Url,
            name: separateFile.files[i].name
          });
        }

        fileUrls.push({ sortKey: separateFile.sortKey, files: files });
      }
    } finally {
      this.progressLoading = false;
    }

    return fileUrls;
  }

  /**
   * ### ファイルアップロード先のURLを発行する
   */
  public async createSeparateUploadUrls(separatefiles: Array<ResidentSeparateFiles>): Promise<S3UploadResponse> {
    let uploadFiles: Array<S3UploadFileInfo> = [];

    for (const files of separatefiles) {
      let extensions: Array<string> = [];

      for (const file of files.files) {
        const _file: Array<string> = file.name.split("/");
        const _extensions: Array<string> = _file[_file.length - 1].split(".");
        extensions.push("." + _extensions[_extensions.length - 1]);
      }

      uploadFiles.push({
        sortKey: files.sortKey,
        count: files.files.length,
        extensions: extensions
      });
    }

    const params: S3UploadSendDocument = {
      unit: Unit.SEPARATE,
      type: this.createTargetType(this.type as SendMessageTarget, this.groupType) as Type,
      files: uploadFiles
    };
    const requestBody: S3MultiLocation = {
      type: S3UploadType.SEND_DOCUMENT,
      params: params,
      acl: "public-read"
    };
    const urls: S3UploadResponse = await this.s3LocationsService.multiPost(userStore, requestBody);

    return urls;
  }

  /**
   * ### 文書送付を更新するためのリクエストボディを作成する
   */
  public async createSendDocumentRequestBody(
    fileUrls: Array<FileUrl>,
    type: SendMessageTarget | null,
    targets: Array<SendTarget>,
    sendType: string
  ): Promise<SendDocumentPatchModel> {
    /**
     * 添付ファイルがない利用者家族は送信しないようにする対応を行うため、添付ファイル情報をMAPにする
     * 利用者ごとに異なる文書でない場合は対応不要なのでnullを格納して明示化している
     */
    let separateFileMap: Map<string, ResidentSeparateFiles> | null = new Map<string, ResidentSeparateFiles>();
    // 利用者ごとに異なる文書かつ、ファイルが存在する場合の添付ファイル情報作成
    if (this.unit == Unit.SEPARATE && 0 < this.separateFiles.length) {
      for (const residentSeparateFile of this.separateFiles) {
        separateFileMap.set(residentSeparateFile.sortKey, residentSeparateFile);
      }
    } else {
      separateFileMap = null;
    }

    let _type = null;
    let receivers: SendDocumentFamilyReceivers | SendDocumentOtherUserReceivers | null = null;
    if (type != null) {
      _type = this.createTargetType(this.type as SendMessageTarget, this.groupType) as Type;
      receivers = await this.createRequestReceivers(targets, _type, separateFileMap, sendType);
    }

    let sendMessageGroupInfos: Array<SendMessageGroupInfo> | null = null;
    let residentGroupInfos: Array<ResidentGroupInfo> | null = null;
    let otherUserGroupInfos: Array<GroupOtherUserGroupInfo> | null = null;
    if (type == SendMessageTarget.GROUPS) {
      switch (this.groupType) {
        case GroupType.FAMILY:
        case GroupType.OTHER_USER: {
          sendMessageGroupInfos = [];
          for (const target of targets) {
            if (target.isTarget == true) {
              const source: SendMessageGroupTargetModel = target.source as SendMessageGroupTargetModel;
              sendMessageGroupInfos.push({
                sendMessageGroupsSortKey: source.sendMessageGroupsSortKey,
                id: source.id,
                name: source.name,
                type: source.type,
                memberSortKeys: source.members
              });
            }
          }
          break;
        }
        case GroupType.RESIDENT_GROUP: {
          // 利用者グループにひもづく家族をMAPでまとめる
          const residentGroupMemberMap = new Map<number, Array<string>>();
          if (this.targetAllFamilies != null) {
            for (const family of this.targetAllFamilies) {
              const residentsSortKeys: Array<string> | undefined = residentGroupMemberMap.get(family.groupId);
              if (residentsSortKeys) {
                residentsSortKeys.push(family.residentsSortKey);
                residentGroupMemberMap.set(family.groupId, residentsSortKeys);
              } else {
                residentGroupMemberMap.set(family.groupId, [family.residentsSortKey]);
              }
            }
          }

          residentGroupInfos = [];
          for (const target of targets) {
            if (target.isTarget == true) {
              const source: ResidentGroupTargetModel = target.source as ResidentGroupTargetModel;
              const residentsSortKeys: Array<string> | undefined = residentGroupMemberMap.get(source.id);
              if (!residentsSortKeys) {
                throw new SystemError("error residentGroup is not found");
              }
              residentGroupInfos.push({
                id: source.id,
                name: source.name,
                residentsSortKeys: residentsSortKeys
              });
            }
          }
          break;
        }
        case GroupType.OTHER_USER_GROUP: {
          // 施設関係者グループにひもづくメンバーをMAPでまとめる
          const otherUserGroupMemberMap = new Map<number, Array<string>>();
          for (const member of this.otherUserGroupMembersInFacility) {
            const memberSortKeys: Array<string> | undefined = otherUserGroupMemberMap.get(member.id);
            if (memberSortKeys) {
              memberSortKeys.push(member.otherUserGroupsSortKey);
              otherUserGroupMemberMap.set(member.id, memberSortKeys);
            } else {
              otherUserGroupMemberMap.set(member.id, [member.otherUserGroupsSortKey]);
            }
          }

          otherUserGroupInfos = [];
          for (const target of targets) {
            if (target.isTarget == true) {
              const source: OtherUserGroupTargetModel = target.source as OtherUserGroupTargetModel;
              const memberSortKeys: Array<string> | undefined = otherUserGroupMemberMap.get(source.id);
              if (!memberSortKeys) {
                throw new SystemError("error OtherUserGroup is not found");
              }
              otherUserGroupInfos.push({
                id: source.id,
                otherUserGroupsSortKey: source.otherUserGroupsSortKey,
                name: source.name,
                memberSortKeys: memberSortKeys
              });
            }
          }
          break;
        }
      }
    }

    const requestBody: SendDocumentPatchModel = {
      isPublic: this.isPublic,
      type: _type,
      receivers: receivers ? receivers.receivers : [],
      receiversByLine: receivers ? receivers.receiversByLine : [],
      receiversByMail: receivers ? receivers.receiversByMail : [],
      sendMessageGroupInfos: sendMessageGroupInfos,
      residentGroupInfos: residentGroupInfos,
      otherUserGroupInfos: otherUserGroupInfos,
      unit: this.unit != null ? this.unit : null,
      categoryId: this.categoryId != null ? this.categoryId : null,
      title: this.title != null ? this.title : null,
      text: this.text != null ? this.text : null,
      needConfirm: this.needConfirm,
      needAgreement: this.needAgreement,
      fileUrls: fileUrls,
      updated: this.updated != null ? this.updated : -1
    };

    return requestBody;
  }

  /**
   * ### 宛先情報を作成する
   */
  public async createRequestReceivers(
    targets: Array<SendTarget>,
    type: Type,
    separateFileMap: Map<string, ResidentSeparateFiles> | null,
    sendType: string
  ): Promise<SendDocumentFamilyReceivers | SendDocumentOtherUserReceivers | null> {
    let receivers: SendDocumentFamilyReceivers | SendDocumentOtherUserReceivers | null = null;

    switch (type) {
      case Type.ALL_FAMILY: {
        if (this.unit == Unit.SAME) {
          receivers = {
            receivers: [],
            receiversByLine: [],
            receiversByMail: []
          };
          break;
        }
        receivers = this.createRequestReceiversToFamily(targets, separateFileMap, sendType);
        break;
      }
      case Type.SELECTED_FAMILY: {
        receivers = this.createRequestReceiversToFamily(targets, separateFileMap, sendType);
        break;
      }
      case Type.SELECTED_OTHER_USER: {
        receivers = this.createRequestReceiversToOtherUserGroup(targets);
        break;
      }
      case Type.SEND_MESSAGE_GROUP: {
        receivers = await this.createRequestReceiversToSendMessageGroup(targets, separateFileMap, sendType);
        break;
      }
      case Type.RESIDENT_GROUP: {
        receivers = this.createRequestReceiversToResidentGroup(targets, separateFileMap, sendType);
        break;
      }
      case Type.OTHER_USER_GROUP: {
        receivers = this.createRequestReceiversToOtherUserGroups(targets);
        break;
      }
    }

    return receivers;
  }

  /**
   * ### 家族の場合の宛先情報を作成する
   */
  public createRequestReceiversToFamily(targets: Array<SendTarget>, separateFileMap: Map<string, ResidentSeparateFiles> | null, sendType: string): SendDocumentFamilyReceivers {
    const receivers: Array<string> = [];
    const receiversByLine: Array<string> = [];
    const receiversByMail: Array<string> = [];

    for (const target of targets) {
      if (target.isTarget == true) {
        if (separateFileMap != null) {
          const residentSeparateFile: ResidentSeparateFiles | undefined = separateFileMap.get(target.key);
          if (sendType == "send" && (residentSeparateFile == undefined || residentSeparateFile.files.length < 1)) {
            continue;
          }
        }

        const source: FamilyGetModel = target.source as FamilyGetModel;
        receivers.push(source.residentsSortKey);

        if (source.senderType == SenderType.LINE) {
          receiversByLine.push(source.residentsSortKey);
        } else if (source.senderType == SenderType.MAIL) {
          receiversByMail.push(source.residentsSortKey);
        }
      }
    }

    return {
      receivers,
      receiversByLine,
      receiversByMail
    };
  }

  /**
   * ### 施設関係者個別の場合の宛先情報を作成する
   */
  public createRequestReceiversToOtherUserGroup(targets: Array<SendTarget>): SendDocumentOtherUserReceivers {
    const receivers: Array<string> = [];
    const receiversByLine: Array<string> = [];
    const receiversByMail: Array<string> = [];

    for (const target of targets) {
      if (target.isTarget == true) {
        const source: OtherUserGroupTypeMember = target.source as OtherUserGroupTypeMember;
        receivers.push(source.otherUserGroupsSortKey);

        if (source.senderType == SenderType.LINE) {
          receiversByLine.push(source.otherUserGroupsSortKey);
        } else if (source.senderType == SenderType.MAIL) {
          receiversByMail.push(source.otherUserGroupsSortKey);
        }
      }
    }

    return {
      receivers,
      receiversByLine,
      receiversByMail
    };
  }

  /**
   * ### 宛先グループの場合の宛先情報を作成する
   */
  public async createRequestReceiversToSendMessageGroup(
    targets: Array<SendTarget>,
    separateFileMap: Map<string, ResidentSeparateFiles> | null,
    sendType: string
  ): Promise<SendDocumentFamilyReceivers | SendDocumentOtherUserReceivers> {
    const receivers: Array<string> = [];
    const receiversByLine: Array<string> = [];
    const receiversByMail: Array<string> = [];

    // ユーザーをreceiversに重複登録しないためにMAP化して登録したreceiverを保持する
    const userMap: Map<string, any> = new Map();

    for (const target of targets) {
      if (target.isTarget == true) {
        const source: SendMessageGroupTargetModel = target.source as SendMessageGroupTargetModel;
        if (source.type == GroupType.FAMILY) {
          this.sendMessageGroupType = GroupType.FAMILY;

          const families: Array<SendMessageGroupMembersFamilyGetModel> = await this.getSendMessageGroupFamilyMembers(source.id);
          for (const family of families) {
            // ソートキーの重複チェック
            if (userMap.has(family.residentsSortKey)) {
              continue;
            } else {
              userMap.set(family.residentsSortKey, family);
            }
            // ファイル情報が存在する場合、宛先に含めるかチェックする
            if (separateFileMap != null) {
              const residentSeparateFile: ResidentSeparateFiles | undefined = separateFileMap.get(family.residentsSortKey);
              if (sendType == "send" && (residentSeparateFile == undefined || residentSeparateFile.files.length < 1)) {
                continue;
              }
            }
            receivers.push(family.residentsSortKey);

            if (family.senderType == SenderType.LINE) {
              receiversByLine.push(family.residentsSortKey);
            } else if (family.senderType == SenderType.MAIL) {
              receiversByMail.push(family.residentsSortKey);
            }
          }
        } else if (source.type == GroupType.OTHER_USER) {
          this.sendMessageGroupType = GroupType.OTHER_USER;

          const members: Array<SendMessageGroupMembersOtherUserGroupMemberGetModel> = await this.getSendMessageGroupOtherGroupUserMembers(source.id);
          for (const member of members) {
            // ソートキーの重複チェック
            if (userMap.has(member.otherUserGroupsSortKey)) {
              continue;
            } else {
              userMap.set(member.otherUserGroupsSortKey, member);
            }
            receivers.push(member.otherUserGroupsSortKey);

            if (member.senderType == SenderType.LINE) {
              receiversByLine.push(member.otherUserGroupsSortKey);
            } else if (member.senderType == SenderType.MAIL) {
              receiversByMail.push(member.otherUserGroupsSortKey);
            }
          }
        }
      }
    }

    return {
      receivers,
      receiversByLine,
      receiversByMail
    } as any;
  }

  /**
   * ### 宛先グループにひもづく家族ユーザーを取得する
   */
  public async getSendMessageGroupFamilyMembers(groupId: number): Promise<Array<SendMessageGroupMembersFamilyGetModel>> {
    const members: Array<SendMessageGroupMembersFamilyGetModel> = (await this.sendMessageGroupMembersService.get(
      userStore,
      groupId
    )) as Array<SendMessageGroupMembersFamilyGetModel>;
    return members;
  }

  /**
   * ### 宛先グループにひもづく施設関係者グループメンバーを取得する
   */
  public async getSendMessageGroupOtherGroupUserMembers(groupId: number): Promise<Array<SendMessageGroupMembersOtherUserGroupMemberGetModel>> {
    const members: Array<SendMessageGroupMembersOtherUserGroupMemberGetModel> = (await this.sendMessageGroupMembersService.get(
      userStore,
      groupId
    )) as Array<SendMessageGroupMembersOtherUserGroupMemberGetModel>;
    return members;
  }

  public createRequestReceiversToResidentGroup(
    targets: Array<SendTarget>,
    separateFileMap: Map<string, ResidentSeparateFiles> | null,
    sendType: string
  ): SendDocumentOtherUserReceivers | SendDocumentOtherUserReceivers {
    const receivers: Array<string> = [];
    const receiversByLine: Array<string> = [];
    const receiversByMail: Array<string> = [];

    // ユーザーをreceiversに重複登録しないためにMAP化して登録したreceiverを保持する
    const userMap: Map<string, any> = new Map();

    for (const target of targets) {
      if (target.isTarget == true) {
        const source: ResidentGroupTargetModel = target.source as ResidentGroupTargetModel;
        if (this.targetAllFamilies != null) {
          for (const family of this.targetAllFamilies) {
            // 利用者グループに存在しなければスキップする
            if (family.groupId != source.id) {
              continue;
            }

            // ソートキーの重複チェック
            if (userMap.has(family.residentsSortKey)) {
              continue;
            } else {
              userMap.set(family.residentsSortKey, family);
            }
            // ファイル情報が存在する場合、宛先に含めるかチェックする
            if (separateFileMap != null) {
              const residentSeparateFile: ResidentSeparateFiles | undefined = separateFileMap.get(family.residentsSortKey);
              if (sendType == "send" && (residentSeparateFile == undefined || residentSeparateFile.files.length < 1)) {
                continue;
              }
            }
            receivers.push(family.residentsSortKey);

            if (family.senderType == SenderType.LINE) {
              receiversByLine.push(family.residentsSortKey);
            } else if (family.senderType == SenderType.MAIL) {
              receiversByMail.push(family.residentsSortKey);
            }
          }
        }
      }
    }

    return {
      receivers,
      receiversByLine,
      receiversByMail
    } as any;
  }

  /**
   * ### 施設関係者個別の場合の宛先情報を作成する
   */
  public createRequestReceiversToOtherUserGroups(targets: Array<SendTarget>): SendDocumentOtherUserReceivers {
    const receivers: Array<string> = [];
    const receiversByLine: Array<string> = [];
    const receiversByMail: Array<string> = [];

    // ユーザーをreceiversに重複登録しないためにMAP化して登録したreceiverを保持する
    const userMap: Map<string, any> = new Map();

    for (const target of targets) {
      if (target.isTarget == true) {
        const source: OtherUserGroupTargetModel = target.source as OtherUserGroupTargetModel;

        for (const member of this.otherUserGroupMembersInFacility) {
          // 施設関係者グループに存在しなければスキップする
          if (member.id != source.id) {
            continue;
          }
          // ソートキーの重複チェック
          if (userMap.has(member.otherUserGroupsSortKey)) {
            continue;
          } else {
            userMap.set(member.otherUserGroupsSortKey, member);
          }

          receivers.push(member.otherUserGroupsSortKey);
          if (member.senderType == SenderType.LINE) {
            receiversByLine.push(member.otherUserGroupsSortKey);
          } else if (member.senderType == SenderType.MAIL) {
            receiversByMail.push(member.otherUserGroupsSortKey);
          }
        }
      }
    }

    return {
      receivers,
      receiversByLine,
      receiversByMail
    };
  }

  public createTargetType(targetType: SendMessageTarget, groupType: GroupType): Type | null {
    switch (targetType) {
      case SendMessageTarget.ALL_FAMILIES: {
        return Type.ALL_FAMILY;
      }
      case SendMessageTarget.FAMILIES: {
        return Type.SELECTED_FAMILY;
      }
      case SendMessageTarget.OTHER_USERS: {
        return Type.SELECTED_OTHER_USER;
      }
      case SendMessageTarget.GROUPS: {
        switch (groupType) {
          case GroupType.FAMILY:
          case GroupType.OTHER_USER: {
            return Type.SEND_MESSAGE_GROUP;
          }
          case GroupType.RESIDENT_GROUP: {
            return Type.RESIDENT_GROUP;
          }
          case GroupType.OTHER_USER_GROUP: {
            return Type.OTHER_USER_GROUP;
          }
        }
      }
    }
    return null;
  }

  /**
   * ### 文書送付送信確認モーダルを表示する
   *
   * - バリデーションを実施する
   * - バリデーションでエラーが無ければモーダルを表示する
   */
  public async showSendConfirmModal(): Promise<void> {
    // バリデーションを実施し、エラーがなければ確認モーダルを表示する
    const targetValidationResult: boolean = this.targetsValidate();
    const fileValidationResult: boolean = this.fileValidate();
    const validationResult: boolean = await this.$validator.validateAll();
    if (validationResult && targetValidationResult && fileValidationResult) {
      this.showValidationAlert = false;
      // 利用者にファイルが添付されているかバリデーションし、ファイル添付されていない利用者がいたら注意喚起モーダルを表示する
      const notTempFileResidents: Array<SendTargetExtFiles> = this.separateFileTargetsValidate();
      if (0 < notTempFileResidents.length) {
        this.showNotTempFileResidents(notTempFileResidents);
      }
      // 全利用者にファイルが添付されていたら送信確認モーダルを表示する
      else {
        this.showCheckbox = this.type == SendMessageTarget.ALL_FAMILIES ? true : false;
        this.checked = !this.showCheckbox;
        this.showSendModal = true;
      }
    } else {
      this.showValidationAlert = true;
    }
    return;
  }

  public showNotTempFileResidents(notTempFileResidents: Array<SendTargetExtFiles>): void {
    const residentMap = new Map();
    for (const resident of notTempFileResidents) {
      residentMap.set(resident.source.id, resident.source);
    }
    const residentNames: string[] = [];
    residentMap.forEach((value) => {
      residentNames.push(`${value.name}（${value.room}）`);
    });
    this.showNotTempFileResidentsModalTitle = "文書送付情報を送付・公開しますか？";
    this.showNotTempFileResidentsModalMessage = "以下の利用者家族には文書送付されません。\n問題がなければ「確認しました」にチェックをしてOKボタンを押してください。";
    this.notTempFileResidentNames = residentNames;
    this.showNotTempFileResidentsModal = true;
    return;
  }

  /**
   * ### 宛先のバリデーション
   *
   * - エラーを初期化する
   * - 宛先の中でisTraget==trueの宛先がいるか探す
   * - 見つかった場合はエラー無しなのでtrueを返す
   * - 見つからなかった場合は種別に応じてメッセージを分岐させ、falseを返す
   */
  public targetsValidate(): boolean {
    this.$validator.errors.remove("targets");
    const firstTarget: SendTarget | undefined = this.targets.find((target: SendTarget) => target.isTarget == true);
    if (firstTarget == undefined) {
      if (this.type == SendMessageTarget.ALL_FAMILIES) {
        this.$validator.errors.add({ field: "type", msg: "ご家族が登録されていないため、メッセージを送ることができません" });
      } else {
        this.$validator.errors.add({ field: "targets", msg: "宛先は必須項目です" });
      }
    }
    return firstTarget == undefined ? false : true;
  }

  /**
   * ### ファイルのバリデーション
   *
   * - エラーを初期化する
   * - 宛先全員同じ文書の場合、ファイルの必須チェックを行う
   * - 利用者ごとに異なる文書の場合、家族ユーザー毎にファイルの必須チェックを行う
   */
  public fileValidate(): boolean {
    this.$validator.errors.remove("same-files");
    this.$validator.errors.remove("separate-files");

    if (this.unit == null) {
      return true;
    }

    // 文書の配信単位：全員同じ文書
    if (this.unit == Unit.SAME) {
      if (this.sameFiles.length <= 0) {
        this.$validator.errors.add({ field: "same-files", msg: "添付文書は必須です" });
        return false;
      }
    }
    // 文書の配信単位：利用者毎に異なる文書
    else if (this.unit == Unit.SEPARATE) {
      /**
       * 宛先対象がいない場合はエラーとして扱う
       */
      if (this.separateFileTargets.length < 1) {
        this.$validator.errors.add({ field: "separate-files", msg: `送信対象の利用者が存在しません` });
        return false;
      }

      /**
       * 全利用者に添付ファイルが存在しない場合はエラーとして扱う
       */
      const separateFileMap: Map<string, ResidentSeparateFiles> = new Map<string, ResidentSeparateFiles>();
      let notExistTempFile: boolean = false;
      for (const residentSeparateFile of this.separateFiles) {
        separateFileMap.set(residentSeparateFile.sortKey, residentSeparateFile);
      }
      for (const target of this.separateFileTargets) {
        if (target.isTarget == false) {
          continue;
        }
        const residentSeparateFile: ResidentSeparateFiles | undefined = separateFileMap.get(target.key);
        if (residentSeparateFile != undefined && 0 < residentSeparateFile.files.length) {
          notExistTempFile = true;
        }
      }
      // 添付ファイルが存在しない場合はエラーを追加する
      if (notExistTempFile == false) {
        this.$validator.errors.add({ field: "separate-files", msg: `ファイルが存在する利用者がいません` });
        return false;
      }
    }
    return true;
  }

  /**
   * ### 利用者に添付ファイルが存在するかのバリデーション
   *
   * - 文書の配信単位：利用者毎に異なる文書 場合、対象の利用者の添付ファイルが存在するかチェックする
   * - 存在しない利用者がいる場合はそれを返す
   */
  public separateFileTargetsValidate(): Array<SendTargetExtFiles> {
    const notTempFileResidents: Array<SendTargetExtFiles> = [];
    if (this.unit == Unit.SEPARATE) {
      const separateFileMap: Map<string, ResidentSeparateFiles> = new Map<string, ResidentSeparateFiles>();
      for (const residentSeparateFile of this.separateFiles) {
        separateFileMap.set(residentSeparateFile.sortKey, residentSeparateFile);
      }
      for (const target of this.separateFileTargets) {
        if (target.isTarget == false) {
          continue;
        }
        const residentSeparateFile: ResidentSeparateFiles | undefined = separateFileMap.get(target.key);
        if (residentSeparateFile == undefined || residentSeparateFile.files.length < 1) {
          notTempFileResidents.push(target);
        }
      }
    }
    return notTempFileResidents;
  }

  /**
   * ### 文書送付送信を実施する
   */
  public async sendDocument(): Promise<void> {
    this.loadingMessage = "送信中...";
    this.isBusy = true;

    // 【安全ガード】S3ファイルアップロード・API送信の直前に、現在有効な宛先（isTarget=true）以外の添付ファイルを確実にクリーンアップする
    await this.cleanSeparateFiles();
    this.setScreenInputTemporaryStore(); // APIリクエスト前にstoreに値を保持する

    let fileUrls: Array<FileUrl> = [];
    // ファイルアップロードするタイミングでファイルが削除（移動含む）、リネームされた場合は失敗するのでここでtry-catchする
    // アップロードに失敗した場合は添付されたファイルを全てリセットしてモーダルで再添付を促す
    try {
      if (this.beforeSendDocument != null && this.beforeSendDocument.isSended == false) {
        // 文書単位が「宛先全員同じ文書」の場合の添付文書S3アップロード
        if (this.unit != null && this.unit == Unit.SAME && 0 < this.sameFiles.length) {
          const files: Array<SendDocumentFile> = await this.uploadSameFiles(this.sameFiles);
          fileUrls = [{ sortKey: "none", files: files }];
        }
        // 文書単位が「利用者ごとに異なる文書」の場合の添付文書S3アップロード
        else if (this.unit != null && this.unit == Unit.SEPARATE && 0 < this.separateFiles.length) {
          fileUrls = await this.uploadSeparateFiles(this.separateFiles);
        }
      }
    } catch (error) {
      this.isBusy = false;

      this.showUploadErrorModal = true;
      this.resetSameFiles();
      this.resetSeparateFiles();

      return;
    }

    const requestBody: SendDocumentSendPostModel = await this.createSendDocumentMessageRequestBody(fileUrls, this.type, this.targets, "send");
    switch (this.type) {
      case SendMessageTarget.ALL_FAMILIES:
      case SendMessageTarget.FAMILIES: {
        await this.sendDocumentsService.sendToFamilies(userStore, this.mainId as number, requestBody);
        break;
      }
      case SendMessageTarget.OTHER_USERS: {
        await this.sendDocumentsService.sendToOtherUserGroups(userStore, this.mainId as number, requestBody);
        break;
      }
      case SendMessageTarget.GROUPS: {
        switch (this.groupType) {
          case GroupType.FAMILY: {
            await this.sendDocumentsService.sendToFamilies(userStore, this.mainId as number, requestBody);
            break;
          }
          case GroupType.OTHER_USER: {
            await this.sendDocumentsService.sendToOtherUserGroups(userStore, this.mainId as number, requestBody);
            break;
          }
          case GroupType.RESIDENT_GROUP: {
            await this.sendDocumentsService.sendToFamilies(userStore, this.mainId as number, requestBody);
            break;
          }
          case GroupType.OTHER_USER_GROUP: {
            await this.sendDocumentsService.sendToOtherUserGroups(userStore, this.mainId as number, requestBody);
            break;
          }
        }
        break;
      }
    }
    this.resetScreenInputTemporaryStore();

    this.showSendSuccessModal = true;
    this.isBusy = false;

    return;
  }

  /**
   * ### 文書送付を登録するためのリクエストボディを作成する
   */
  public async createSendDocumentMessageRequestBody(
    fileUrls: Array<FileUrl>,
    type: SendMessageTarget | null,
    targets: Array<SendTarget>,
    sendType: string
  ): Promise<SendDocumentSendPostModel> {
    /**
     * 添付ファイルがない利用者家族は送信しないようにする対応を行うため、添付ファイル情報をMAPにする
     * 利用者ごとに異なる文書でない場合は対応不要なのでnullを格納して明示化している
     */
    let separateFileMap: Map<string, ResidentSeparateFiles> | null = new Map<string, ResidentSeparateFiles>();
    // 利用者ごとに異なる文書かつ、ファイルが存在する場合の添付ファイル情報作成
    if (this.unit == Unit.SEPARATE && 0 < this.separateFiles.length) {
      for (const residentSeparateFile of this.separateFiles) {
        separateFileMap.set(residentSeparateFile.sortKey, residentSeparateFile);
      }
    } else {
      separateFileMap = null;
    }

    let _type = null;
    let receivers: SendDocumentFamilyReceivers | SendDocumentOtherUserReceivers | null = null;
    if (type != null) {
      _type = this.createTargetType(this.type as SendMessageTarget, this.groupType) as Type;
      receivers = await this.createRequestReceivers(targets, _type, separateFileMap, sendType);
    }

    let sendMessageGroupInfos: Array<SendMessageGroupInfo> | null = null;
    let residentGroupInfos: Array<ResidentGroupInfo> | null = null;
    let otherUserGroupInfos: Array<GroupOtherUserGroupInfo> | null = null;
    if (type == SendMessageTarget.GROUPS) {
      switch (this.groupType) {
        case GroupType.FAMILY:
        case GroupType.OTHER_USER: {
          sendMessageGroupInfos = [];
          for (const target of targets) {
            if (target.isTarget == true) {
              const source: SendMessageGroupTargetModel = target.source as SendMessageGroupTargetModel;
              sendMessageGroupInfos.push({
                sendMessageGroupsSortKey: source.sendMessageGroupsSortKey,
                id: source.id,
                name: source.name,
                type: source.type,
                memberSortKeys: source.members
              });
            }
          }
          break;
        }
        case GroupType.RESIDENT_GROUP: {
          // 利用者グループにひもづく家族をMAPでまとめる
          const residentGroupMemberMap = new Map<number, Array<string>>();
          if (this.targetAllFamilies != null) {
            for (const family of this.targetAllFamilies) {
              const residentsSortKeys: Array<string> | undefined = residentGroupMemberMap.get(family.groupId);
              if (residentsSortKeys) {
                residentsSortKeys.push(family.residentsSortKey);
                residentGroupMemberMap.set(family.groupId, residentsSortKeys);
              } else {
                residentGroupMemberMap.set(family.groupId, [family.residentsSortKey]);
              }
            }
          }

          residentGroupInfos = [];
          for (const target of targets) {
            if (target.isTarget == true) {
              const source: ResidentGroupTargetModel = target.source as ResidentGroupTargetModel;
              const residentsSortKeys: Array<string> | undefined = residentGroupMemberMap.get(source.id);
              if (!residentsSortKeys) {
                throw new SystemError("error residentGroup is not found");
              }
              residentGroupInfos.push({
                id: source.id,
                name: source.name,
                residentsSortKeys: residentsSortKeys
              });
            }
          }
          break;
        }
        case GroupType.OTHER_USER_GROUP: {
          // 施設関係者グループにひもづくメンバーをMAPでまとめる
          const otherUserGroupMemberMap = new Map<number, Array<string>>();
          for (const member of this.otherUserGroupMembersInFacility) {
            const memberSortKeys: Array<string> | undefined = otherUserGroupMemberMap.get(member.id);
            if (memberSortKeys) {
              memberSortKeys.push(member.otherUserGroupsSortKey);
              otherUserGroupMemberMap.set(member.id, memberSortKeys);
            } else {
              otherUserGroupMemberMap.set(member.id, [member.otherUserGroupsSortKey]);
            }
          }

          otherUserGroupInfos = [];
          for (const target of targets) {
            if (target.isTarget == true) {
              const source: OtherUserGroupTargetModel = target.source as OtherUserGroupTargetModel;
              const memberSortKeys: Array<string> | undefined = otherUserGroupMemberMap.get(source.id);
              if (!memberSortKeys) {
                throw new SystemError("error OtherUserGroup is not found");
              }
              otherUserGroupInfos.push({
                id: source.id,
                otherUserGroupsSortKey: source.otherUserGroupsSortKey,
                name: source.name,
                memberSortKeys: memberSortKeys
              });
            }
          }
          break;
        }
      }
    }

    const requestBody: SendDocumentSendPostModel = {
      type: _type,
      receivers: receivers ? receivers.receivers : [],
      receiversByLine: receivers ? receivers.receiversByLine : [],
      receiversByMail: receivers ? receivers.receiversByMail : [],
      sendMessageGroupInfos: sendMessageGroupInfos,
      residentGroupInfos: residentGroupInfos,
      otherUserGroupInfos: otherUserGroupInfos,
      unit: this.unit as Unit,
      categoryId: this.categoryId as number,
      title: this.title as string,
      text: this.text as string,
      needConfirm: this.needConfirm,
      needAgreement: this.needAgreement,
      fileUrls: fileUrls
    };

    return requestBody;
  }

  /**
   * ### 文書送付一覧に遷移する
   */
  public gotoSendDocumentList(): void {
    this.$router.push(PcUrl.SendDocumentList);
    return;
  }

  /**
   * ### Mapを配列に変換する
   */
  public mapToArray<T>(map: Map<any, T>): Array<T> {
    const array: any[] = [];
    for (const [key, value] of map) {
      array.push(value);
    }
    return array;
  }

  /**
   * ### 宛先選択ボタン押下イベント
   *
   * - 文書単位やファイル情報を初期化する
   * - 宛先種別に応じてモーダルを表示する
   */
  public onTargetSelect(type: SendMessageTarget): void {
    switch (type) {
      case SendMessageTarget.FAMILIES: {
        if (this.targetFamilies != null) {
          this.showTargetFamiliesSelectModal(this.targetFamilies);
        }
        break;
      }
      case SendMessageTarget.OTHER_USERS: {
        if (this.targetOtherUsers != null) {
          this.showTargetOtherUserGroupsSelectModal(this.targetOtherUsers);
        }
        break;
      }
      case SendMessageTarget.GROUPS: {
        if (this.targetGroups != null) {
          this.showTargetSendMessageGroupsSelectModal(this.targetGroups);
        }
        break;
      }
    }
    return;
  }

  /**
   * ### 宛先選択モーダル(家族個別)を表示する
   *
   * - メモリ渡しだと値変更が共有されてしまう
   * - 値変更後に「キャンセル」された場合に困るので、コピーしたものを渡す
   */
  public showTargetFamiliesSelectModal(targetFamilies: Array<SendTargetResidentGroup>): void {
    const copy: Array<SendMessageTargetGroup> = JSON.parse(JSON.stringify(targetFamilies));
    const modal: any = this.$refs.sendMessageSelectModal;
    modal.show(copy);
    return;
  }

  /**
   * ### 宛先選択モーダル(家族個別)でOKボタンイベント処理
   *
   * 【仕様】
   * 家族選択モーダルで選択された家族情報を反映します。
   * 同じ宛先種別（家族個別）のまま家族を追加選択した場合は、既存の利用者の添付ファイル（separateFiles）は保持されます。
   * モーダル上でチェックを外した家族がいる場合は、`cleanSeparateFiles()` により選択解除された家族の添付ファイルのみが除外されます。
   */
  public async selectSendTargetFamilies(targets: Array<SendTargetResidentGroup>): Promise<void> {
    this.targetFamilies = targets;
    if (this.targetFamilies != null) {
      this.targets = this.createSendTargetFamilies(this.targetFamilies, this.residentMapById);
    }
    await this.cleanSeparateFiles();
    return;
  }

  /**
   * ### 宛先選択モーダル(施設関係者個別)を表示する
   *
   * - メモリ渡しだと値変更が共有されてしまう
   * - 値変更後に「キャンセル」された場合に困るので、コピーしたものを渡す
   */
  public showTargetOtherUserGroupsSelectModal(targetOtherUsers: Array<OtherUserGroupTypeGroup>): void {
    const copy: Array<OtherUserGroupTypeGroup> = JSON.parse(JSON.stringify(targetOtherUsers));
    const modal: any = this.$refs.otherUserGroupSelectModal;
    modal.show(copy);
    return;
  }

  /**
   * ### 宛先選択モーダル(施設関係者個別)でOKボタンイベント処理
   *
   * 【仕様】
   * 施設関係者選択モーダルで選択されたメンバー情報を反映します。
   * モーダル上でチェックを外したメンバーがいる場合は、`cleanSeparateFiles()` により選択解除されたメンバーの添付ファイルを除外します。
   */
  public async selectSendTargetOtherUserGroups(targets: Array<OtherUserGroupTypeGroup>): Promise<void> {
    this.targetOtherUsers = targets;
    if (this.targetOtherUsers != null) {
      this.targets = this.createSendTargetOtherUsers(this.targetOtherUsers);
    }
    await this.cleanSeparateFiles();
    return;
  }

  /**
   * ### 宛先選択モーダル(宛先グループ)を表示する
   *
   * - メモリ渡しだと値変更が共有されてしまう
   * - 値変更後に「キャンセル」された場合に困るので、コピーしたものを渡す
   */
  public showTargetSendMessageGroupsSelectModal(targetGroups: GroupModel): void {
    // メモリ渡しだと値変更が共有されてしまう
    // 値変更後に「キャンセル」された場合に困るので、コピーしたものを渡す
    const copy: GroupModel = JSON.parse(JSON.stringify(targetGroups));
    const modal: any = this.$refs.sendMessageGroupSelectModal;
    modal.show(copy);
    return;
  }

  /**
   * ### 宛先選択モーダル(宛先グループ)でOKボタンイベント処理
   *
   * 【仕様】
   * - 選択されたグループ情報を受け取り、表示用宛先を作成します。
   * - 選択されたグループ種別（家族系 / 施設関係者系）に応じて、配信単位の選択肢を切り替えます。
   * - 【グループ種別変更時のリセット仕様】:
   *   前回と異なるグループ種別（例：家族グループ ↔ 施設関係者グループなど）が選択された場合は、
   *   配信対象カテゴリが根本的に変わるため `changeUnit()` で添付ファイルを全リセットします。
   *   同じグループ種別のままグループを追加・変更した場合は `cleanSeparateFiles()` により、
   *   選択解除されたグループのファイルのみを除去し、継続選択されているグループのファイルは保持します。
   */
  public async selectSendTargetSendMessageGroups(targets: GroupModel): Promise<void> {
    const prevGroupType = this.sendMessageGroupType;
    this.targetGroups = targets;

    if (this.targetGroups != null) {
      this.targets = this.createSendTargetGroups(this.targetGroups);
    }

    switch (this.groupType) {
      case GroupType.FAMILY:
      case GroupType.RESIDENT_GROUP: {
        this.unitOptions = [
          { value: Unit.SAME, label: "宛先全員同じ文書" },
          { value: Unit.SEPARATE, label: "利用者ごとに異なる文書" }
        ];
        break;
      }
      case GroupType.OTHER_USER:
      case GroupType.OTHER_USER_GROUP: {
        this.unitOptions = [{ value: Unit.SAME, label: "宛先全員同じ文書" }];
        this.unit = Unit.SAME;
        break;
      }
    }

    // グループ種別が変わっていた場合は添付文書をリセットする
    if (prevGroupType !== GroupType.UNKNOWN && prevGroupType !== this.groupType) {
      this.changeUnit();
    } else {
      await this.cleanSeparateFiles();
    }
    this.sendMessageGroupType = this.groupType;
    return;
  }

  /**
   * ### 宛先メンバーの削除ボタン押下イベント
   *
   * 【仕様】
   * - 画面上の宛先リストで削除（×ボタン）された対象の `isTarget` を `false` に更新します。
   * - 宛先種別に応じて実際の候補データのチェック状態を同期更新します。
   * - `cleanSeparateFiles()` を呼び出し、削除された宛先に紐づいていた添付ファイルを自動削除・クリーンアップします。
   */
  public async onDeleteTarget(deleteTarget: SendTarget): Promise<void> {
    for (let target of this.targets) {
      if (target.key == deleteTarget.key) {
        target.isTarget = false;
        break;
      }
    }
    switch (this.type) {
      case SendMessageTarget.FAMILIES: {
        if (this.targetFamilies != null) {
          this.deleteTargetFamily(this.targetFamilies, deleteTarget);
        }
        break;
      }
      case SendMessageTarget.OTHER_USERS: {
        if (this.targetOtherUsers != null) {
          this.deleteTargetOtherUser(this.targetOtherUsers, deleteTarget);
        }
        break;
      }
      case SendMessageTarget.GROUPS: {
        if (this.targetGroups != null) {
          this.deleteTargetGroup(this.targetGroups, deleteTarget);
        }
        break;
      }
    }
    await this.cleanSeparateFiles();
    return;
  }

  /**
   * ### 宛先(家族個別)の削除
   */
  public deleteTargetFamily(targetFamilies: Array<SendTargetResidentGroup>, deleteTarget: SendTarget): void {
    for (const target of targetFamilies) {
      for (const resident of target.residents) {
        for (const family of resident.families) {
          if (family.residentsSortKey == deleteTarget.key) {
            family.isTarget = false;
          }
        }
      }
    }
    return;
  }

  /**
   * ### 宛先(施設関係者個別)の削除
   */
  public deleteTargetOtherUser(targetOtherUsers: Array<OtherUserGroupTypeGroup>, deleteTarget: SendTarget): void {
    for (const otherUser of targetOtherUsers) {
      for (const member of otherUser.members) {
        if (member.otherUserGroupsSortKey == deleteTarget.key) {
          member.isTarget = false;
        }
      }
    }
    return;
  }

  /**
   * ### 宛先(宛先グループ)の削除
   */
  public deleteTargetGroup(targetGroups: GroupModel, deleteTarget: SendTarget): void {
    for (const familyGroup of targetGroups.familyGroups) {
      if (familyGroup.sendMessageGroupsSortKey == deleteTarget.key) {
        familyGroup.isTarget = false;
      }
    }
    for (const otherUserGroup of targetGroups.otherUserGroupMemberGroups) {
      if (otherUserGroup.sendMessageGroupsSortKey == deleteTarget.key) {
        otherUserGroup.isTarget = false;
      }
    }
    for (const residentGroup of targetGroups.residentGroups) {
      if (residentGroup.key == deleteTarget.key) {
        residentGroup.isTarget = false;
      }
    }
    for (const otherUserGroup of targetGroups.otherUserGroups) {
      if (otherUserGroup.key == deleteTarget.key) {
        otherUserGroup.isTarget = false;
      }
    }
    return;
  }

  /**
   * ### 全員同じ文書の入力イベント
   */
  public inputSameFiles(newValue: Array<File>): void {
    if (this.sameFilesValidate(newValue, this.sameFiles) == true) {
      this.sameFiles = this.sameFiles.concat(newValue);
    }
    return;
  }

  /**
   * ### 同じ文書のファイルバリデーション
   *
   * - エラーを初期化する
   * - PDFファイル以外はエラーなのでfalseを返す
   * - 現在登録しているファイル＋登録しようとしているファイルが最大登録ファイル数を超える場合はエラーとして扱う
   * - エラー無しならばtrueを返す
   */
  public sameFilesValidate(files: Array<File>, currentSameFiles: Array<File>): boolean {
    this.$validator.errors.remove("same-files");
    for (let file of files) {
      if (file.type != "application/pdf") {
        this.$validator.errors.add({ field: "same-files", msg: `PDFファイル以外は登録できません` });
        return false;
      }
      const fileSizeLimit: number = 1024 * 1024 * 50; // 50MBまでとする
      if (fileSizeLimit < file.size) {
        this.$validator.errors.add({ field: "same-files", msg: `添付文書のファイルサイズが50MBを超えているため登録できません` });
        return false;
      }
    }
    if (this.registerFileUploadLimit < files.length + currentSameFiles.length) {
      this.$validator.errors.add({ field: "same-files", msg: `最大登録ファイル数以上は登録できません` });
      return false;
    }
    return true;
  }

  /**
   * ### 添付ファイルプレビューボタン押下イベント処理
   *
   * - ダイアログで添付ファイルをプレビュー表示する
   */
  public async onSameFilePreview(): Promise<void> {
    this.isBusy = true;
    this.loadingMessage = "読込み中...";

    const modal: SendMessageFilePreviewModal | Vue | Element | Vue[] | Element[] = this.$refs.previewModal;
    if (modal instanceof SendMessageFilePreviewModal) {
      const previewSameFile: File[] = [];
      for (const file of this.sameFiles) {
        const _file: any = file;
        // 一時保存されていたファイルの場合、初期処理でFileオブジェクトではなく、nameとurlのObject型のデータを格納している
        // urlがある場合はS3からファイルをダウンロードし、Fileオブジェクトに変換する
        if (_file.url != null) {
          const updatedFile: File = await this.getS3File(_file.url, _file.name);
          previewSameFile.push(updatedFile);
        } else {
          previewSameFile.push(file);
        }
      }
      // S3からファイル取得したものも含めて、sameFilesを更新する
      this.sameFiles = previewSameFile;

      modal.show("", false, this.sameFiles);
    }

    this.isBusy = false;

    return;
  }

  /**
   * ### 宛先全員同じ文章の指定されたファイルを削除する
   */
  public onSameFileDelete(index: number): void {
    this.sameFiles.splice(index, 1);
    return;
  }

  /**
   * ### 宛先全員同じ文章の登録可能なファイル数を返す
   */
  get _sameFilesLimit(): number {
    const limit: number = this.registerFileUploadLimit - this.sameFiles.length;
    return limit;
  }

  /**
   * ### 宛先全員同じ文章のプレビューの表示可否を返す
   */
  get _enableSameFilesPreview(): boolean {
    return 0 < this.sameFiles.length ? true : false;
  }

  /**
   * ### 利用者ごとに異なる文書の選択モーダルを表示する
   */
  public async onSelectSeparateFile(): Promise<void> {
    this.setScreenInputTemporaryStore();
    this.loadingMessage = "読込み中...";
    this.isBusy = true;
    this.separateFileTargetsIsLoading = true;

    let sortKeyFilesMap: Map<string, Array<File>> = new Map<string, Array<File>>();
    for (const files of this.separateFiles) {
      sortKeyFilesMap.set(files.sortKey, files.files);
    }
    let separateFileTargets: Array<SendTargetExtFiles> = [];
    switch (this.type) {
      case SendMessageTarget.ALL_FAMILIES:
      case SendMessageTarget.FAMILIES: {
        for (const target of this.targets) {
          const files: Array<File> | undefined = sortKeyFilesMap.get(target.key);
          separateFileTargets.push({
            ...target,
            files: files != undefined ? files : []
          });
        }
        break;
      }
      case SendMessageTarget.GROUPS: {
        switch (this.groupType) {
          case GroupType.FAMILY: {
            for (const target of this.targets) {
              if (target.isTarget == true) {
                const source: SendMessageGroupTargetModel = target.source as SendMessageGroupTargetModel;
                const families: Array<SendMessageGroupMembersFamilyGetModel> = await this.getSendMessageGroupFamilyMembers(source.id);

                for (const family of families) {
                  const resident: ResidentGetModel | undefined = this.residentMapById.get(family.id);
                  const insuredNumberKey: string | null = resident
                    ? resident.insuredNumber && resident.careInsuranceInsuredNumber
                      ? `${resident.insuredNumber}_${resident.careInsuranceInsuredNumber}`
                      : null
                    : null;
                  const files: Array<File> | undefined = sortKeyFilesMap.get(family.residentsSortKey as string);
                  separateFileTargets.push({
                    isTarget: true,
                    key: family.residentsSortKey as string,
                    insuredNumberKey: insuredNumberKey,
                    label: family.familyName as string,
                    source: family,
                    files: files != undefined ? files : []
                  });
                }
              }
            }
            break;
          }
          case GroupType.RESIDENT_GROUP: {
            for (const target of this.targets) {
              if (target.isTarget == true) {
                const source: SendMessageGroupTargetModel = target.source as SendMessageGroupTargetModel;
                if (this.targetAllFamilies != null) {
                  for (const family of this.targetAllFamilies) {
                    // 利用者グループに存在しなければスキップする
                    if (family.groupId != source.id) {
                      continue;
                    }

                    const resident: ResidentGetModel | undefined = this.residentMapById.get(family.id);
                    const insuredNumberKey: string | null = resident
                      ? resident.insuredNumber && resident.careInsuranceInsuredNumber
                        ? `${resident.insuredNumber}_${resident.careInsuranceInsuredNumber}`
                        : null
                      : null;
                    const files: Array<File> | undefined = sortKeyFilesMap.get(family.residentsSortKey as string);
                    separateFileTargets.push({
                      isTarget: true,
                      key: family.residentsSortKey as string,
                      insuredNumberKey: insuredNumberKey,
                      label: family.familyName as string,
                      source: family,
                      files: files != undefined ? files : []
                    });
                  }
                }
              }
            }
            break;
          }
        }
        break;
      }
    }
    // モーダル表示で使用する情報を作成する
    const separateFileTargetsItems: Array<SeparateFileSelectTableItem> = [];
    const residents: Array<ResidentGetModel> = await this.getResidents();
    const items: Array<SeparateFileSelectTableItem> = [];
    for (const resident of residents) {
      if (resident.familyCount == 0) {
        continue;
      }
      const group: ResidentGroupsGetModel | undefined = this.residentGroupMap.get(resident.groupId);
      items.push({
        residentSortKey: resident.residentsSortKey,
        groupId: resident.groupId,
        groupName: group ? group.name : "",
        residentId: resident.id,
        residentName: resident.name,
        room: resident.room,
        insuredNumberKey: `${resident.insuredNumber}_${resident.careInsuranceInsuredNumber}`,
        targetFamilies: [],
        files: []
      });
    }
    for (const item of items) {
      const targetFamilies: Array<SendTargetExtFiles> = [];
      for (const target of separateFileTargets) {
        if (item.residentId == target.source.id && target.isTarget == true) {
          targetFamilies.push({
            ...target,
            label: `${target.source.familyName}（${target.source.familyRelation}）`
          });
        }
      }
      if (0 < targetFamilies.length) {
        item.targetFamilies = targetFamilies;
        item.files = targetFamilies[0].files;
        separateFileTargetsItems.push(item);
      }
    }

    this.isBusy = false;
    this.separateFileTargets = separateFileTargets;
    this.separateFileTargetsItems = separateFileTargetsItems;
    this.separateFileTargetsRows = separateFileTargetsItems.length;
    this.showSeparateFileSelectModal = true;
    this.separateFileTargetsIsLoading = false;

    this.resetScreenInputTemporaryStore();
    return;
  }

  /**
   * ### グッドツリー連携ファイル取得イベント
   */
  public async downloadGoodTreeFiles(files: Array<GoodTreeFile>): Promise<void> {
    this.isBusy = true;
    this.loadingMessage = "読込み中...";

    this.setScreenInputTemporaryStore();

    // S3からファイルを取得
    const s3FilesMapByCareNumber: Map<string, Array<File>> = new Map<string, Array<File>>();
    for (const file of files) {
      const s3File: File = await this.goodTreeFilesService.getS3File(userStore, Setting.backets.imageExpireHour, file);
      const key: string = `${file.insuredNumber}_${file.careInsuranceInsuredNumber}`;
      if (s3FilesMapByCareNumber.has(key)) {
        s3FilesMapByCareNumber.get(key)!.push(s3File);
      } else {
        s3FilesMapByCareNumber.set(key, [s3File]);
      }
    }

    // 宛先にファイルを付与する
    for (const target of this.separateFileTargets) {
      if (!target.isTarget || !target.insuredNumberKey) {
        continue;
      }
      const files: Array<File> | undefined = s3FilesMapByCareNumber.get(target.insuredNumberKey);
      if (files && 0 < files.length) {
        if (this.registerFileUploadLimit < target.files.length + files.length) {
          continue;
        }
        target.files = target.files.concat(files);
      }
    }

    // 表示する利用者にファイルを付与する
    for (const item of this.separateFileTargetsItems) {
      const files: Array<File> | undefined = s3FilesMapByCareNumber.get(item.insuredNumberKey);
      if (files && 0 < files.length) {
        if (this.registerFileUploadLimit < item.files.length + files.length) {
          this.$validator.errors.add({ field: item.residentSortKey, msg: `最大登録ファイル数以上は登録できません` });
          continue;
        }
        item.files = item.files.concat(files);
      }
    }

    this.resetScreenInputTemporaryStore();

    this.isBusy = false;
    this.separateFileTargetsIsLoading = false;
    this.showCooperationSystemSelectModal = false;

    return;
  }

  /**
   * ### iMedicファイルを取得して対応する利用者に付与する
   *
   * @param files CooperationSystemSelectModalからemitされたiMedicのファイル情報
   */
  async downloadIMedicFiles(files: Array<IMedicFile>): Promise<void> {
    this.isBusy = true;
    this.loadingMessage = "読込み中...";

    this.setScreenInputTemporaryStore();

    // S3からファイルを取得
    const s3FilesMapByCareNumber: Map<string, Array<File>> = new Map<string, Array<File>>();
    for (const file of files) {
      const s3File: File = await this.iMedicFilesService.getS3File(userStore, Setting.backets.imageExpireHour, file);
      const key: string = `${file.insuredNumber}_${file.careInsuranceInsuredNumber}`;
      if (s3FilesMapByCareNumber.has(key)) {
        s3FilesMapByCareNumber.get(key)!.push(s3File);
      } else {
        s3FilesMapByCareNumber.set(key, [s3File]);
      }
    }

    // 宛先にファイルを付与する
    for (const target of this.separateFileTargets) {
      if (!target.isTarget || !target.insuredNumberKey) {
        continue;
      }
      const files: Array<File> | undefined = s3FilesMapByCareNumber.get(target.insuredNumberKey);
      if (files && 0 < files.length) {
        if (this.registerFileUploadLimit < target.files.length + files.length) {
          continue;
        }
        target.files = target.files.concat(files);
      }
    }

    // 表示する利用者にファイルを付与する
    for (const item of this.separateFileTargetsItems) {
      const files: Array<File> | undefined = s3FilesMapByCareNumber.get(item.insuredNumberKey);
      if (files && 0 < files.length) {
        if (this.registerFileUploadLimit < item.files.length + files.length) {
          this.$validator.errors.add({ field: item.residentSortKey, msg: `最大登録ファイル数以上は登録できません` });
          continue;
        }
        item.files = item.files.concat(files);
      }
    }

    this.resetScreenInputTemporaryStore();

    this.isBusy = false;
    this.separateFileTargetsIsLoading = false;

    return;
  }

  /**
   * ### 福祉見聞録（東経システム）ファイルを取得して対応する利用者に付与する
   *
   * @param files CooperationSystemSelectModalからemitされた福祉見聞録のファイル情報
   */
  async downloadToukeiFiles(files: Array<ToukeiFile>): Promise<void> {
    this.isBusy = true;
    this.loadingMessage = "読込み中...";

    this.setScreenInputTemporaryStore();

    // S3からファイルを取得
    const s3FilesMapByCareNumber: Map<string, Array<File>> = new Map<string, Array<File>>();
    for (const file of files) {
      const s3File: File = await this.toukeiFilesService.getS3File(userStore, Setting.backets.imageExpireHour, file);
      const key: string = `${file.insuredNumber}_${file.careInsuranceInsuredNumber}`;
      if (s3FilesMapByCareNumber.has(key)) {
        s3FilesMapByCareNumber.get(key)!.push(s3File);
      } else {
        s3FilesMapByCareNumber.set(key, [s3File]);
      }
    }

    // 宛先にファイルを付与する
    for (const target of this.separateFileTargets) {
      if (!target.isTarget || !target.insuredNumberKey) {
        continue;
      }
      const files: Array<File> | undefined = s3FilesMapByCareNumber.get(target.insuredNumberKey);
      if (files && 0 < files.length) {
        if (this.registerFileUploadLimit < target.files.length + files.length) {
          continue;
        }
        target.files = target.files.concat(files);
      }
    }

    // 表示する利用者にファイルを付与する
    for (const item of this.separateFileTargetsItems) {
      const files: Array<File> | undefined = s3FilesMapByCareNumber.get(item.insuredNumberKey);
      if (files && 0 < files.length) {
        if (this.registerFileUploadLimit < item.files.length + files.length) {
          this.$validator.errors.add({ field: item.residentSortKey, msg: `最大登録ファイル数以上は登録できません` });
          continue;
        }
        item.files = item.files.concat(files);
      }
    }

    this.resetScreenInputTemporaryStore();

    this.isBusy = false;
    this.separateFileTargetsIsLoading = false;

    return;
  }

  /**
   * ### 利用者ごとに異なる文書のファイル選択結果
   */
  public selectedSeparateFiles(files: Array<ResidentSeparateFiles>): void {
    this.separateFiles = files;
    return;
  }

  /**
   * ### 利用者ごとに異なる文書の選択モーダルで連携システムから取得ボタン押下イベント
   */
  public onCooperationSystemSelect(): void {
    this.showCooperationSystemSelectModal = true;
    return;
  }

  /**
   * ### 利用者ごとに異なる文書の一覧モーダルを表示する
   */
  public async onSeparateFileList(): Promise<void> {
    this.loadingMessage = "読込み中...";
    this.isBusy = true;
    this.separateFileTargetsIsLoading = true;

    let sortKeyFilesMap: Map<string, Array<File>> = new Map<string, Array<File>>();
    for (const files of this.separateFiles) {
      sortKeyFilesMap.set(files.sortKey, files.files);
    }
    // モーダル表示で使用する情報を作成する
    const separateFileTargetsItems: Array<SeparateFileTableItem> = [];
    const residents: Array<ResidentGetModel> = await this.getResidents();
    const items: Array<SeparateFileTableItem> = [];
    for (const resident of residents) {
      if (resident.familyCount == 0) {
        continue;
      }
      const group: ResidentGroupsGetModel | undefined = this.residentGroupMap.get(resident.groupId);
      items.push({
        residentSortKey: resident.residentsSortKey,
        groupId: resident.groupId,
        groupName: group ? group.name : "",
        residentId: resident.id,
        residentName: resident.name,
        room: resident.room,
        insuredNumberKey: `${resident.insuredNumber}_${resident.careInsuranceInsuredNumber}`,
        targetFamilies: [],
        files: []
      });
    }
    for (const item of items) {
      const targetFamilies: Array<SendTargetExtFiles> = [];
      const separateFileTargets = this.separateFileTargets;
      for (const target of separateFileTargets) {
        if (item.residentId == target.source.id && target.isTarget == true) {
          targetFamilies.push({
            ...target,
            label: `${target.source.familyName}（${target.source.familyRelation}）`
          });
        }
      }
      if (0 < targetFamilies.length) {
        item.targetFamilies = targetFamilies;
        item.files = targetFamilies[0].files;
        separateFileTargetsItems.push(item);
      }
    }

    this.isBusy = false;
    this.separateFileTargetsItems = separateFileTargetsItems;
    this.separateFileTargetsRows = separateFileTargetsItems.length;
    this.separateFileTargetsIsLoading = false;
    this.showSeparateFileListModal = true;
    return;
  }

  /** ### 送付日時を返す */
  get _sendDatetime(): string {
    if (this.beforeSendDocument == null || this.beforeSendDocument.sendDatetime == null) {
      return "";
    }
    const sendDatetime: string = this.$dateUtil.convertNumberToString(this.beforeSendDocument.sendDatetime as number, "yyyy年mm月dd日 hh:MM", false);

    return sendDatetime;
  }

  /** ### 宛先種別文字列を返す */
  get _typeLabel(): string {
    if (this.beforeSendDocument == null) {
      return "";
    }

    switch (this.beforeSendDocument.type) {
      case Type.ALL_FAMILY: {
        return "家族全員";
      }
      case Type.SELECTED_FAMILY: {
        return "家族個別";
      }
      case Type.SELECTED_OTHER_USER: {
        return "施設関係者個別";
      }
      case Type.SEND_MESSAGE_GROUP: {
        return "宛先グループ";
      }
      case Type.RESIDENT_GROUP: {
        return "利用者グループ";
      }
      default: {
        return "";
      }
    }
  }

  /** ### 宛先文字列を返す */
  get _sendTargetLabel(): string {
    if (this.beforeSendDocument == null) {
      return "";
    }

    const sendTargets: string[] = [];
    switch (this.beforeSendDocument.type) {
      case Type.ALL_FAMILY: {
        sendTargets.push("家族全員");
        break;
      }
      case Type.SELECTED_FAMILY: {
        for (const receiver of this.beforeSendDocument.receivers as Array<SendDocumentFamilyReceiver>) {
          sendTargets.push(`${receiver.familyName}（${receiver.room}・${receiver.name}）`);
        }
        break;
      }
      case Type.SELECTED_OTHER_USER: {
        for (const receiver of this.beforeSendDocument.receivers as Array<SendDocumentOtherUserReceiver>) {
          sendTargets.push(receiver.memberName);
        }
        break;
      }
      case Type.SEND_MESSAGE_GROUP: {
        for (const group of this.beforeSendDocument.sendMessageGroupInfos as Array<SendMessageGroupInfo>) {
          sendTargets.push(group.name);
        }
        break;
      }
      case Type.RESIDENT_GROUP: {
        for (const group of this.beforeSendDocument.residentGroupInfos as Array<ResidentGroupInfo>) {
          sendTargets.push(group.name);
        }
        break;
      }
      case Type.OTHER_USER_GROUP: {
        for (const group of this.beforeSendDocument.otherUserGroupInfos as Array<GroupOtherUserGroupInfo>) {
          sendTargets.push(group.name);
        }
        break;
      }
    }

    return sendTargets.join("、");
  }

  /** ### 文書の配信単位文字列を返す */
  get _unitLabel(): string {
    if (this.beforeSendDocument == null) {
      return "";
    }

    switch (this.beforeSendDocument.unit) {
      case Unit.SAME: {
        return "宛先全員同じ文書";
      }
      case Unit.SEPARATE: {
        return "利用者ごとに異なる文書";
      }
      default: {
        return "";
      }
    }
  }

  /** ### 文書の配信単位を返す */
  get _unit(): Unit {
    if (this.beforeSendDocument == null) {
      return Unit.UNKNOWN;
    }

    return this.beforeSendDocument.unit;
  }

  /** ### 添付文書名のリストを返す */
  get _fileNames(): string[] {
    if (this.beforeSendDocument == null) {
      return [];
    }

    if (this.beforeSendDocument.unit != Unit.SAME) {
      return [];
    }

    const fileNames: string[] = [];
    for (const fileUrl of this.beforeSendDocument.fileUrls) {
      for (const file of fileUrl.files) {
        fileNames.push(file.name);
      }
    }

    return fileNames;
  }

  /** ### カテゴリ文字列を返す */
  get _category(): string {
    if (this.beforeSendDocument == null) {
      return "";
    }

    const categoryName: string | undefined = this.categoryMap.get(this.beforeSendDocument.categoryId);
    return categoryName != undefined ? categoryName : "";
  }

  /** ### タイトル文字列を返す */
  get _title(): string {
    if (this.beforeSendDocument == null) {
      return "";
    }

    return this.beforeSendDocument.title;
  }

  /** ### 本文文字列を返す */
  get _text(): string {
    if (this.beforeSendDocument == null) {
      return "";
    }

    return this.beforeSendDocument.text;
  }

  /** ###  */
  get _option(): string {
    if (this.beforeSendDocument == null) {
      return "";
    }

    if (this.beforeSendDocument.needAgreement == true) {
      return "同意取得";
    } else if (this.beforeSendDocument.needConfirm == true) {
      return "確認取得";
    } else {
      return "オプション無し";
    }
  }
  /**
   * ### 画面入力情報をstoreから復元し、store情報を初期化する
   */
  public restoreScreenInputTemporaryStore(): void {
    if (screenInputTemporaryStore.url == PcUrl.SendDocumentEdit) {
      this.isPublic = screenInputTemporaryStore.inputParams.isPublic;
      this.type = screenInputTemporaryStore.inputParams.type;
      this.targets = screenInputTemporaryStore.inputParams.targets;
      this.targetAllFamilies = screenInputTemporaryStore.inputParams.targetAllFamilies;
      this.targetFamilies = screenInputTemporaryStore.inputParams.targetFamilies;
      this.targetOtherUsers = screenInputTemporaryStore.inputParams.targetOtherUsers;
      this.targetGroups = screenInputTemporaryStore.inputParams.targetGroups;
      this.unit = screenInputTemporaryStore.inputParams.unit;
      if (screenInputTemporaryStore.inputParams.sameFiles && 0 < screenInputTemporaryStore.inputParams.sameFiles.length) {
        this.sameFiles = screenInputTemporaryStore.inputParams.sameFiles;
      }
      if (screenInputTemporaryStore.inputParams.separateFileTargets && 0 < screenInputTemporaryStore.inputParams.separateFileTargets.length) {
        this.separateFileTargets = screenInputTemporaryStore.inputParams.separateFileTargets;
      }
      if (screenInputTemporaryStore.inputParams.separateFiles && 0 < screenInputTemporaryStore.inputParams.separateFiles.length) {
        this.separateFiles = screenInputTemporaryStore.inputParams.separateFiles;
      }
      // 復元するとタイトルと本文が上書きされるので復元しない
      // this.templateId = screenInputTemporaryStore.inputParams.templateId;
      this.categoryId = screenInputTemporaryStore.inputParams.categoryId;
      this.title = screenInputTemporaryStore.inputParams.title;
      this.text = screenInputTemporaryStore.inputParams.text;
      this.needConfirm = screenInputTemporaryStore.inputParams.needConfirm;
      this.needAgreement = screenInputTemporaryStore.inputParams.needAgreement;

      this.resetScreenInputTemporaryStore();
    }
    return;
  }

  /**
   * ### 画面入力情報のstoreをリセットする
   */
  public resetScreenInputTemporaryStore(): void {
    screenInputTemporaryStore.initializeScreenInputTemporary();
    return;
  }

  /**
   * ### 現在有効な宛先（isTarget == true）のソートキー（sortKey / residentsSortKey）一覧を取得する
   *
   * 【目的・背景】
   * 宛先選択モーダルでの宛先解除、画面上での宛先削除、あるいはグループ種別の変更が行われた際、
   * 「選択解除された宛先の添付ファイル」が `separateFiles` 内に残存してしまうのを防ぐためのガード処理で使用します。
   *
   * 【仕様】
   * 宛先種別（`this.type`）およびグループ種別（`this.groupType`）に応じて、現在送信対象としてチェックが入っている（`isTarget == true`）
   * 家族・利用者の `residentsSortKey` または 施設関係者メンバーの `otherUserGroupsSortKey` のSetを構築して返却します。
   */
  public async getValidTargetSortKeys(): Promise<Set<string>> {
    const validKeys = new Set<string>();
    if (this.targets == null || this.type == null) {
      return validKeys;
    }

    switch (this.type) {
      case SendMessageTarget.ALL_FAMILIES:
      case SendMessageTarget.FAMILIES: {
        for (const target of this.targets) {
          if (target.isTarget == true) {
            validKeys.add(target.key);
          }
        }
        break;
      }
      case SendMessageTarget.OTHER_USERS: {
        for (const target of this.targets) {
          if (target.isTarget == true) {
            validKeys.add(target.key);
          }
        }
        break;
      }
      case SendMessageTarget.GROUPS: {
        for (const target of this.targets) {
          if (target.isTarget == true) {
            switch (this.groupType) {
              case GroupType.FAMILY: {
                const source: SendMessageGroupTargetModel = target.source as SendMessageGroupTargetModel;
                const families: Array<SendMessageGroupMembersFamilyGetModel> = await this.getSendMessageGroupFamilyMembers(source.id);
                for (const family of families) {
                  validKeys.add(family.residentsSortKey);
                }
                break;
              }
              case GroupType.RESIDENT_GROUP: {
                const source: ResidentGroupTargetModel = target.source as ResidentGroupTargetModel;
                if (this.targetAllFamilies != null) {
                  for (const family of this.targetAllFamilies) {
                    if (family.groupId == source.id) {
                      validKeys.add(family.residentsSortKey);
                    }
                  }
                }
                break;
              }
              case GroupType.OTHER_USER: {
                const source: SendMessageGroupTargetModel = target.source as SendMessageGroupTargetModel;
                const members: Array<SendMessageGroupMembersOtherUserGroupMemberGetModel> = await this.getSendMessageGroupOtherGroupUserMembers(source.id);
                for (const member of members) {
                  validKeys.add(member.otherUserGroupsSortKey);
                }
                break;
              }
              case GroupType.OTHER_USER_GROUP: {
                const source: OtherUserGroupTargetModel = target.source as OtherUserGroupTargetModel;
                for (const member of this.otherUserGroupMembersInFacility) {
                  if (member.id == source.id) {
                    validKeys.add(member.otherUserGroupsSortKey);
                  }
                }
                break;
              }
            }
          }
        }
        break;
      }
    }
    return validKeys;
  }

  /**
   * ### 有効な宛先以外の添付ファイルをクリーンアップする（ガード処理）
   *
   * 【目的・背景】
   * モーダルで宛先のチェックを外した場合や、宛先削除ボタン押下時、あるいはファイルアップロード・一時保存・送信の直前に呼び出します。
   * 宛先から外れた利用者の添付ファイルが誤ってS3にアップロードされたり、他人に送付されたりする事故を完全に防ぐための安全ガードです。
   *
   * 【仕様】
   * 配信単位が「利用者ごとに異なる文書」（`Unit.SEPARATE`）の場合に実行します。
   * `getValidTargetSortKeys()` で現在有効な宛先のソートキー一覧を取得し、
   * `this.separateFiles` の中から有効な宛先のキーに紐づくデータのみを残すフィルター処理を行います。
   */
  public async cleanSeparateFiles(): Promise<void> {
    if (this.unit != Unit.SEPARATE || this.separateFiles.length === 0) {
      return;
    }
    const validKeys: Set<string> = await this.getValidTargetSortKeys();
    this.separateFiles = this.separateFiles.filter((file) => validKeys.has(file.sortKey));
    return;
  }

  /**
   * ### 画面入力情報をstoreに格納する
   *
   * - 一時間無操作タイムアウト対策としてAPIリクエスト前にstoreに保存する
   */
  public setScreenInputTemporaryStore(): void {
    screenInputTemporaryStore.setScreenInputTemporary({
      url: PcUrl.SendDocumentEdit,
      inputParams: {
        isPublic: this.isPublic,
        type: this.type,
        targets: this.targets,
        targetAllFamilies: this.targetAllFamilies,
        targetFamilies: this.targetFamilies,
        targetOtherUsers: this.targetOtherUsers,
        targetGroups: this.targetGroups,
        unit: this.unit,
        sameFiles: this.sameFiles,
        separateFileTargets: this.separateFileTargets,
        separateFiles: this.separateFiles,
        templateId: this.templateId,
        categoryId: this.categoryId,
        title: this.title,
        text: this.text,
        needConfirm: this.needConfirm,
        needAgreement: this.needAgreement
      }
    });
    return;
  }
}

/**
 * ### 家族個別の宛先選択モーダル表示用情報
 */
export interface SendTargetResidentGroup extends ResidentGroupsGetModel {
  /** 利用者グループID */
  id: number;
  /** 利用者グループ名 */
  name: string;
  /** モーダルの表示可否 */
  show: boolean;
  /** 利用者 */
  residents: Array<SendTargetResident>;
}

/**
 * ###  家族個別の宛先選択モーダル表示用情報利用者
 */
export interface SendTargetResident extends FamilyGetModel {
  /** モーダルの表示可否 */
  show: boolean;
  /** 家族 */
  families: Array<SendTargetFamily>;
}

/**
 * ### 家族個別の宛先選択モーダル表示用情報家族
 */
export interface SendTargetFamily extends FamilyGetModel {
  /** モーダルの表示可否 */
  show: boolean;
  /** 宛先対象か否か */
  isTarget: boolean;
}

/**
 * ### 宛先グループの宛先選択モーダル表示用情報
 */
export interface SendTargetSendMessageGroup extends SendMessageGroupsGetModel {
  isTarget: boolean;
}

export interface ResidentSeparateFiles {
  sortKey: string;
  files: Array<File>;
}

interface SendDocumentFamilyReceivers {
  receivers: Array<string>;
  receiversByLine: Array<string>;
  receiversByMail: Array<string>;
}

interface SendDocumentOtherUserReceivers {
  receivers: Array<string>;
  receiversByLine: Array<string>;
  receiversByMail: Array<string>;
}
export enum SendMessageTarget {
  UNKNOWN = "",
  ALL_FAMILIES = "allFamilies",
  FAMILIES = "families",
  OTHER_USERS = "otherUsers",
  GROUPS = "groups"
}
</script>

<style lang="scss" scoped>
#send-document-edit {
  max-width: 880px;
  margin-left: auto;
  margin-right: auto;

  // チェックボックスは横一列に並べる
  .checkboxs {
    .register-row {
      width: 180px;
      height: 60px;
    }
    .second-option {
      margin-top: 27px;
      height: 34px;
    }
  }
  .preview-btn {
    width: 120px;
    min-width: 120px;
    max-width: 120px;
  }

  .register-btn,
  .cancel-btn {
    width: 120px;
  }

  .use-cooperation-systems {
    margin: 8px 0 8px 0;

    // 画像でセレクトボックスを表現するので、input要素自体は非表示にする
    input[type="checkbox"] {
      display: none;

      // input要素の代わりに画像つきのspanにする
      // 選択しているか否かで画像を切り替える
      // for属性でcheckboxと紐づかせたspan要素のclickで、チェックボックスの状態が変更される
      & + span {
        // チェックボックス画像が全て表示されるように高さを指定する
        height: 46px;
        // チェックボックス画像が文字より大きく、文字が縦中央揃えに出来ないので、paddingで上下余白を取って位置調整
        padding: 6px 0 0 40px;
        background: url("../../../assets/login-checkbox-off.png") no-repeat left center;
        // チェックボックス画像のサイズを指定
        // 正方形なので要素の高さと同じになる
        background-size: 32px 32px;
      }
      &:checked + span {
        background: url("../../../assets/login-checkbox-on.png") no-repeat left center;
        // チェックボックス画像のサイズを指定
        // 正方形なので要素の高さと同じになる
        background-size: 32px 32px;
      }
    }
    .text {
      margin: 0 !important;
    }
  }
}
</style>
